var _defs, _sodipodiNamedview, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _g, _g2, _g3, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _g4, _path190, _path191, _g5, _path192, _path193, _path194, _path195, _path196, _g6, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _g7, _g8, _g9, _path208, _path209, _g10, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolarPanel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gridItem__media",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1195.2043 914.3562",
    xmlSpace: "preserve",
    fill: "none",
    sodipodiDocname: "solar-panel2.svg",
    inkscapeVersion: "1.1.2 (b8e25be833, 2022-02-05)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3549"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview3547",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    inkscapeZoom: 0.59916667,
    inkscapeCx: 576.63421,
    inkscapeCy: 455.63282,
    "inkscapeWindow-width": 1680,
    "inkscapeWindow-height": 987,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "Layer_1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 44.37262,909.6462 0.1926201,367.9852 c -1.126,-13.796 2.711,-27.541 10.8199999,-38.76 l 220.48,-305.149995 c 5.891,-8.155 13.799,-14.6400004 22.949,-18.8210004 9.151,-4.181 19.23,-5.91399998 29.251,-5.02899998 L 1038.5006,66.775205 c 11.95,1.054 23.28,5.779 32.43,13.526 9.15,7.747 15.69,18.137 18.7,29.743995 l 103.71,399.13 c 2.55,9.817 2.48,20.127 -0.19,29.91 l -101.48,371.901 z",
    fill: "#f4f4f4",
    id: "path2998"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 1077.5706,236.9962 h -25 v 5 h 25 z",
    fill: "#b2b6bb",
    id: "path3000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 1128.0706,259.9962 H 930.07062 v -6 h 196.99998 z",
    fill: "#b2b6bb",
    id: "path3002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 969.31062,212.7062 c 0,0 -13.22,1.81 -74,0.55 -16.43,10 -87.66,3.63 -115.75,1 -32.448,6 -48.498,-9.7 -34.088,-18.18 4.44,-2.63 11.79,-4.57 22.46,-5 -0.7,-33.78 82.868,-44.86 106.158,4.44 12.32,-10 38,-9.06 39.72,4.44 23.78,-4.36 42.56,0.56 51.15,5.72 4.54,2.72 6.24,5.5 4.35,7.03 z",
    fill: "#ffffff",
    id: "path3004"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "m 969.31062,212.7062 c 0,0 -13.22,1.81 -74,0.55 -16.43,10 -87.66,3.63 -115.75,1 -32.448,6 -48.498,-9.7 -34.088,-18.18 -0.114,2.111 0.604,4.183 2,5.77 3.29,3.77 9.49,5.33 15.16,4.85 5.67,-0.48 10.89,-2.7 15.628,-5.25 2.26,-1.23 4.59,-2.58 7.29,-2.84 4.81,-0.47 9,2.57 12.35,5.38 2.78,-4.51 9.85,-7 15.79,-5.46 5.94,1.54 10.06,6.74 9.2,11.73 11.63,-2.07 23.48,3.48 35.33,2.6 13.52,-1 25.7,-10.29 39,-7.93 3.36,0.59 6.46,1.91 9.82,2.47 3.35,0.391 6.73,0.481 10.09,0.27 10.81,-0.2 21.65,1.19 32.45,0.64 5.23,-0.218 10.41,-1.091 15.42,-2.6 4.5,2.69 6.2,5.47 4.31,7 z",
    fill: "#21252b",
    id: "path3006"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 1141.2306,914.3562 H 4.0736201 c -0.466,-0.03 -0.901,-0.24 -1.219,-0.59 -0.318,-0.34 -0.495,-0.79 -0.495,-1.25 0,-0.47 0.177,-0.92 0.495,-1.26 0.318,-0.35 0.753,-0.56 1.219,-0.59 H 1141.2306 c 0.47,0.03 0.9,0.24 1.22,0.59 0.32,0.34 0.5,0.79 0.5,1.26 0,0.46 -0.18,0.91 -0.5,1.25 -0.32,0.35 -0.75,0.56 -1.22,0.59 z",
    fill: "#b2b6bb",
    id: "path3008"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 613.21862,238.0062 h -25 v 5 h 25 z",
    fill: "#b2b6bb",
    id: "path3010"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m 733.06862,255.0062 h -267.35 v 6 h 267.35 z",
    fill: "#b2b6bb",
    id: "path3012"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m 602.80962,222.9462 h -5.38 v 36.46 h 5.38 z",
    fill: "#61656d",
    id: "path3014"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m 600.32262,233.7252 c 8.152,0 14.76,-1.495 14.76,-3.34 0,-1.844 -6.608,-3.34 -14.76,-3.34 -8.152,0 -14.76,1.496 -14.76,3.34 0,1.845 6.608,3.34 14.76,3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3016"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m 585.57062,223.7052 c 0,-1.84 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.5 14.76,3.34 0,1.84 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.49 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3018"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m 585.57062,217.0262 c 0,-1.85 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.49 14.76,3.34 0,1.85 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.5 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3020"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m 600.32262,213.6862 c 8.152,0 14.76,-1.495 14.76,-3.34 0,-1.845 -6.608,-3.34 -14.76,-3.34 -8.152,0 -14.76,1.495 -14.76,3.34 0,1.845 6.608,3.34 14.76,3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3022"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m 609.08262,208.8362 h -17.91 v 22.74 h 17.91 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3024"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m 601.06162,349.3852 -92.53,-77.22 3.41,-4.05 89.09,74.35 90.53,-76.84 3.44,4.03 z",
    fill: "#61656d",
    id: "path3026"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m 613.52262,241.1862 h -24.96 v 669.82 h 24.96 z",
    fill: "#868a91",
    id: "path3028"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m 733.07062,259.4162 h -267.5 v 16.47 h 267.5 z",
    fill: "#868a91",
    id: "path3030"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m 483.70862,222.9462 h -5.38 v 36.46 h 5.38 z",
    fill: "#61656d",
    id: "path3032"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m 481.22162,233.7252 c 8.151,0 14.76,-1.495 14.76,-3.34 0,-1.844 -6.609,-3.34 -14.76,-3.34 -8.152,0 -14.76,1.496 -14.76,3.34 0,1.845 6.608,3.34 14.76,3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3034"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m 466.46162,223.7052 c 0,-1.84 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.5 14.76,3.34 0,1.84 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.49 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3036"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m 466.46162,217.0262 c 0,-1.85 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.49 14.76,3.34 0,1.85 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.5 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3038"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m 481.22162,213.6862 c 8.151,0 14.76,-1.495 14.76,-3.34 0,-1.845 -6.609,-3.34 -14.76,-3.34 -8.152,0 -14.76,1.495 -14.76,3.34 0,1.845 6.608,3.34 14.76,3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3040"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m 489.98062,208.8362 h -17.91 v 22.74 h 17.91 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3042"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m 720.35662,222.9462 h -5.38 v 36.46 h 5.38 z",
    fill: "#61656d",
    id: "path3044"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m 703.10962,230.3852 c 0,-1.84 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.5 14.76,3.34 0,1.84 -6.61,3.35 -14.76,3.35 -8.15,0 -14.76,-1.5 -14.76,-3.35 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3046"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m 703.10962,223.7052 c 0,-1.84 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.5 14.76,3.34 0,1.84 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.49 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3048"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m 703.10962,217.0262 c 0,-1.85 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.49 14.76,3.34 0,1.85 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.5 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3050"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m 703.10962,210.3462 c 0,-1.85 6.61,-3.35 14.76,-3.35 8.15,0 14.76,1.5 14.76,3.35 0,1.85 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.51 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3052"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m 726.62862,208.8362 h -17.91 v 22.74 h 17.91 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3054"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m 1067.8106,222.9462 h -5.38 v 36.46 h 5.38 z",
    fill: "#61656d",
    id: "path3056"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m 1065.3206,233.7252 c 8.15,0 14.76,-1.495 14.76,-3.34 0,-1.844 -6.61,-3.34 -14.76,-3.34 -8.15,0 -14.76,1.496 -14.76,3.34 0,1.845 6.61,3.34 14.76,3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3058"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m 1050.5706,223.7052 c 0,-1.84 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.5 14.76,3.34 0,1.84 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.49 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3060"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m 1050.5706,217.0262 c 0,-1.85 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.49 14.76,3.34 0,1.85 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.5 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3062"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m 1065.3206,213.6862 c 8.15,0 14.76,-1.495 14.76,-3.34 0,-1.845 -6.61,-3.34 -14.76,-3.34 -8.15,0 -14.76,1.495 -14.76,3.34 0,1.845 6.61,3.34 14.76,3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3064"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m 1074.0806,208.8362 h -17.91 v 22.74 h 17.91 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3066"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m 1134.6606,283.3652 -69.63,59.1 -89.08998,-74.35 -3.41,4.05 92.52998,77.22 71.08,-60.33 z",
    fill: "#61656d",
    id: "path3068"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m 1077.5206,241.1862 h -24.96 v 669.82 h 24.96 z",
    fill: "#868a91",
    id: "path3070"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 1128.4406,259.4162 H 929.57062 v 16.46 h 203.14998 z",
    fill: "#868a91",
    id: "path3072"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m 947.71062,222.9462 h -5.38 v 36.46 h 5.38 z",
    fill: "#61656d",
    id: "path3074"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m 945.22062,233.7252 c 8.15,0 14.76,-1.495 14.76,-3.34 0,-1.844 -6.61,-3.34 -14.76,-3.34 -8.15,0 -14.76,1.496 -14.76,3.34 0,1.845 6.61,3.34 14.76,3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3076"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m 930.46062,223.7052 c 0,-1.84 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.5 14.76,3.34 0,1.84 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.49 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3078"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m 930.46062,217.0262 c 0,-1.85 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.49 14.76,3.34 0,1.85 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.5 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3080"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m 945.22062,213.6862 c 8.15,0 14.76,-1.495 14.76,-3.34 0,-1.845 -6.61,-3.34 -14.76,-3.34 -8.15,0 -14.76,1.495 -14.76,3.34 0,1.845 6.61,3.34 14.76,3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3082"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m 953.98062,208.8362 h -17.91 v 22.74 h 17.91 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3084"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m 651.44162,696.9962 h -101.09 v 215 h 101.09 z",
    fill: "#b2b6bb",
    id: "path3086"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 651.06262,697.3752 h -24.14 v 214.251 h 24.14 z",
    fill: "#000000",
    id: "path3088"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m 620.88862,703.4162 h -138.81 v 202.18 h 138.81 z",
    fill: "#868a91",
    id: "path3090"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m 612.97862,887.1262 h -13.97 v -0.79 h 13.18 v -15.06 h -51.29 v -12.36 h 12.31 v -4.989 h -12.31 v -13.61 h 59.18 v 0.79 h -58.4 v 12.04 h 12.32 v 6.559 h -12.32 v 10.79 h 51.3 z",
    fill: "#ffffff",
    id: "path3092"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 554.07062,702.9962 h -69 v 204 h 69 z",
    fill: "#000000",
    id: "path3094"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m 614.09762,733.5862 h -27.16 v 33.19 h 27.16 z",
    fill: "#dadddf",
    id: "path3096"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m 599.01062,820.3462 h -44.94 v 12.07 h 44.94 z",
    fill: "#f4f4f4",
    id: "path3098"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m 620.88962,850.5162 h -48.28 v 12.07 h 48.28 z",
    fill: "#dadddf",
    id: "path3100"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m 599.01062,880.6962 h -44.94 v 12.07 h 44.94 z",
    fill: "#f4f4f4",
    id: "path3102"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m 605.79862,738.8652 h -13.58 v 2.26 h 13.58 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3104"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 614.09862,733.5862 h -3.02 v 33.19 h 3.02 z",
    fill: "#000000",
    id: "path3106"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m 586.94162,746.8052 h -11.71 v -9.05 l -20.88,0.05 v -0.79 l 21.67,-0.05 v 9.05 h 10.92 z",
    fill: "#ffffff",
    id: "path3108"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m 611.46662,822.9952 h -12.46 v -0.78 h 11.68 v -10.53 h -46.02 v -61.11 h -10.19 v -0.78 h 10.97 v 61.1 h 46.02 z",
    fill: "#ffffff",
    id: "path3110"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m 486.07062,702.9962 h -4 v 203 h 4 z",
    fill: "#b2b6bb",
    id: "path3112"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m 604.95662,829.8962 h -5.95 v -0.79 h 5.17 v -27.21 h -34 v -58.42 h -15.7 v -0.79 h 16.48 v 58.42 h 34 z",
    fill: "#ffffff",
    id: "path3114"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m 131.07062,239.9962 h -25 v 5 h 25 z",
    fill: "#b2b6bb",
    id: "path3116"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m 251.18062,263.3972 h -192.11 l 4,-6 h 188.11 z",
    fill: "#b2b6bb",
    id: "path3118"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m 120.80962,224.9462 h -5.38 v 36.46 h 5.38 z",
    fill: "#61656d",
    id: "path3120"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m 118.32262,235.7252 c 8.152,0 14.76,-1.495 14.76,-3.34 0,-1.844 -6.608,-3.34 -14.76,-3.34 -8.152,0 -14.76,1.496 -14.76,3.34 0,1.845 6.608,3.34 14.76,3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3122"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m 103.57062,225.7052 c 0,-1.84 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.5 14.76,3.34 0,1.84 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.49 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3124"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m 103.57062,219.0262 c 0,-1.85 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.49 14.76,3.34 0,1.85 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.5 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3126"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m 118.32262,215.6862 c 8.152,0 14.76,-1.495 14.76,-3.34 0,-1.845 -6.608,-3.34 -14.76,-3.34 -8.152,0 -14.76,1.495 -14.76,3.34 0,1.845 6.608,3.34 14.76,3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3128"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m 127.08262,210.8362 h -17.91 v 22.74 h 17.91 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3130"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m 119.06462,351.3852 93.94,-79.73 -3.44,-4.03 -90.53,76.84 -74.26,-61.97 -3.11,4.3 z",
    fill: "#61656d",
    id: "path3132"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m 131.52262,243.1862 h -24.96 v 669.82 h 24.96 z",
    fill: "#868a91",
    id: "path3134"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m 48.10962,277.8762 h 202.96 v -16.46 h -191.06 z",
    fill: "#868a91",
    id: "path3136"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m 238.35662,224.9462 h -5.38 v 36.46 h 5.38 z",
    fill: "#61656d",
    id: "path3138"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m 221.10962,232.3852 c 0,-1.84 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.5 14.76,3.34 0,1.84 -6.61,3.35 -14.76,3.35 -8.15,0 -14.76,-1.5 -14.76,-3.35 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3140"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m 221.10962,225.7052 c 0,-1.84 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.5 14.76,3.34 0,1.84 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.49 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3142"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m 221.10962,219.0262 c 0,-1.85 6.61,-3.34 14.76,-3.34 8.15,0 14.76,1.49 14.76,3.34 0,1.85 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.5 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3144"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m 221.10962,212.3462 c 0,-1.85 6.61,-3.35 14.76,-3.35 8.15,0 14.76,1.5 14.76,3.35 0,1.85 -6.61,3.34 -14.76,3.34 -8.15,0 -14.76,-1.51 -14.76,-3.34 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3146"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m 244.62862,210.8362 h -17.91 v 22.74 h 17.91 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3148"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m 818.61062,906.3562 19.51,-0.25 45.56,-189.84 -19.51,0.24 z",
    fill: "#b2b6bb",
    id: "path3150"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m 786.38062,910.5762 h 87.49 c 0,-2.46 -0.97,-4.82 -2.71,-6.55 -1.74,-1.74 -4.1,-2.72 -6.56,-2.72 h -68.95 c -2.46,0 -4.81,0.98 -6.55,2.72 -1.74,1.73 -2.72,4.09 -2.72,6.55 z",
    fill: "#868a91",
    id: "path3152"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m 993.07062,822.6762 -8.53,-42.12 -0.02,-0.09 -28.38,-140.19 -275.843,0.03 36.92,182.41 52.4,-0.01 h 0.49 58.643 0.18 l 58.38,-0.01 h 0.4 l 58.25,-0.01 h 0.53 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3154"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 993.07062,822.6762 -8.53,-42.12 -0.02,-0.09 -28.38,-140.19 -275.843,0.03 36.92,182.41 52.4,-0.01 h 0.49 58.643 0.18 l 58.38,-0.01 h 0.4 l 58.25,-0.01 h 0.53 z",
    fill: "#000000",
    id: "path3156"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m 993.13062,819.0762 -271.797,0.03 -36.38,-178.8 271.787,-0.03 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3158"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 993.13062,819.0762 -271.797,0.03 -36.38,-178.8 271.787,-0.03 z",
    fill: "#ffffff",
    id: "path3160"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m 774.09262,819.6052 h -1.54 l -0.08,-0.4 -36.41,-178.92 h 1.54 l 0.09,0.4 z",
    fill: "#ffffff",
    id: "path3162"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m 832.01062,819.5962 h -1.54 l -0.08,-0.4 -36.41,-178.92 h 1.54 l 0.08,0.4 z",
    fill: "#ffffff",
    id: "path3164"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m 889.93062,819.5862 h -1.54 l -0.09,-0.4 -36.4,-178.92 h 1.54 l 0.08,0.4 z",
    fill: "#ffffff",
    id: "path3166"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m 947.85062,819.5762 h -1.55 l -0.08,-0.4 -36.4,-178.92 h 1.54 l 0.08,0.4 z",
    fill: "#ffffff",
    id: "path3168"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m 693.17762,683.2452 -0.31,-1.49 272.823,-0.04 0.3,1.49 z",
    fill: "#ffffff",
    id: "path3170"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m 702.84762,730.7862 -0.3,-1.49 272.813,-0.04 0.3,1.49 z",
    fill: "#ffffff",
    id: "path3172"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m 712.51862,778.3152 -0.3,-1.49 272.812,-0.04 0.31,1.49 z",
    fill: "#ffffff",
    id: "path3174"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m 746.48862,687.7472 -6.66,-5.25 4.52,-5.26 6.67,5.26 z",
    fill: "#ffffff",
    id: "path3176"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m 756.20762,735.5262 -6.66,-5.25 4.52,-5.26 6.67,5.26 z",
    fill: "#ffffff",
    id: "path3178"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m 804.67062,687.7372 -6.67,-5.25 4.53,-5.26 6.67,5.26 z",
    fill: "#ffffff",
    id: "path3180"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m 814.39062,735.5262 -6.66,-5.26 4.52,-5.26 6.67,5.26 z",
    fill: "#ffffff",
    id: "path3182"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m 862.59062,687.7352 -6.67,-5.26 4.53,-5.26 6.66,5.26 z",
    fill: "#ffffff",
    id: "path3184"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m 919.98062,687.7252 -6.66,-5.26 4.53,-5.25 6.66,5.25 z",
    fill: "#ffffff",
    id: "path3186"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m 765.84262,782.8272 -6.67,-5.26 4.53,-5.26 6.66,5.26 z",
    fill: "#ffffff",
    id: "path3188"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m 824.01062,782.8172 -6.66,-5.26 4.53,-5.25 6.66,5.25 z",
    fill: "#ffffff",
    id: "path3190"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m 881.93062,782.8052 -6.66,-5.26 4.52,-5.25 6.67,5.25 z",
    fill: "#ffffff",
    id: "path3192"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m 939.33062,782.7952 -6.66,-5.25 4.52,-5.26 6.67,5.25 z",
    fill: "#ffffff",
    id: "path3194"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m 929.71062,735.5062 -6.67,-5.26 4.53,-5.25 6.66,5.25 z",
    fill: "#ffffff",
    id: "path3196"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m 872.31062,735.5162 -6.66,-5.26 4.52,-5.25 6.67,5.25 z",
    fill: "#ffffff",
    id: "path3198"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m 278.60962,906.3562 19.51,-0.25 45.56,-189.84 -19.51,0.24 z",
    fill: "#b2b6bb",
    id: "path3200"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m 246.38262,910.5762 h 87.49 c 0,-2.46 -0.976,-4.82 -2.715,-6.55 -1.738,-1.74 -4.096,-2.72 -6.554,-2.72 h -68.951 c -2.458,0 -4.816,0.98 -6.554,2.72 -1.739,1.73 -2.716,4.09 -2.716,6.55 z",
    fill: "#868a91",
    id: "path3202"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m 453.06762,822.6762 -8.53,-42.12 -0.02,-0.09 -28.38,-140.19 -275.84,0.03 36.92,182.41 52.4,-0.01 h 0.49 58.64 0.18 l 58.38,-0.01 h 0.4 l 58.25,-0.01 h 0.53 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3204"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 453.06762,822.6762 -8.53,-42.12 -0.02,-0.09 -28.38,-140.19 -275.84,0.03 36.92,182.41 52.4,-0.01 h 0.49 58.64 0.18 l 58.38,-0.01 h 0.4 l 58.25,-0.01 h 0.53 z",
    fill: "#000000",
    id: "path3206"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m 453.13362,819.0762 -271.8,0.03 -36.38,-178.8 271.79,-0.03 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3208"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 453.13362,819.0762 -271.8,0.03 -36.38,-178.8 271.79,-0.03 z",
    fill: "#ffffff",
    id: "path3210"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m 234.09262,819.6052 h -1.54 l -0.08,-0.4 -36.41,-178.92 h 1.54 l 0.09,0.4 z",
    fill: "#ffffff",
    id: "path3212"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m 292.00662,819.5962 h -1.54 l -0.08,-0.4 -36.41,-178.92 h 1.54 l 0.08,0.4 z",
    fill: "#ffffff",
    id: "path3214"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m 349.92862,819.5862 h -1.54 l -0.08,-0.4 -36.41,-178.92 h 1.54 l 0.08,0.4 z",
    fill: "#ffffff",
    id: "path3216"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m 407.85062,819.5762 h -1.54 l -0.09,-0.4 -36.4,-178.92 h 1.54 l 0.08,0.4 z",
    fill: "#ffffff",
    id: "path3218"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m 153.17762,683.2452 -0.31,-1.49 272.82,-0.04 0.3,1.49 z",
    fill: "#ffffff",
    id: "path3220"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m 162.84762,730.7862 -0.3,-1.49 272.81,-0.04 0.3,1.49 z",
    fill: "#ffffff",
    id: "path3222"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m 172.51862,778.3152 -0.3,-1.49 272.81,-0.04 0.31,1.49 z",
    fill: "#ffffff",
    id: "path3224"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m 206.48862,687.7472 -6.66,-5.25 4.52,-5.26 6.67,5.26 z",
    fill: "#ffffff",
    id: "path3226"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m 216.20762,735.5262 -6.66,-5.25 4.52,-5.26 6.67,5.26 z",
    fill: "#ffffff",
    id: "path3228"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m 264.67062,687.7372 -6.67,-5.25 4.53,-5.26 6.67,5.26 z",
    fill: "#ffffff",
    id: "path3230"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m 274.38662,735.5262 -6.66,-5.26 4.52,-5.26 6.67,5.26 z",
    fill: "#ffffff",
    id: "path3232"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m 322.59262,687.7352 -6.67,-5.26 4.53,-5.26 6.66,5.26 z",
    fill: "#ffffff",
    id: "path3234"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m 379.98062,687.7252 -6.66,-5.26 4.53,-5.25 6.66,5.25 z",
    fill: "#ffffff",
    id: "path3236"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m 225.84262,782.8272 -6.67,-5.26 4.53,-5.26 6.66,5.26 z",
    fill: "#ffffff",
    id: "path3238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m 284.01162,782.8172 -6.66,-5.26 4.53,-5.25 6.66,5.25 z",
    fill: "#ffffff",
    id: "path3240"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m 341.93362,782.8052 -6.66,-5.26 4.52,-5.25 6.67,5.25 z",
    fill: "#ffffff",
    id: "path3242"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m 399.33262,782.7952 -6.66,-5.25 4.52,-5.26 6.67,5.25 z",
    fill: "#ffffff",
    id: "path3244"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m 389.70962,735.5062 -6.67,-5.26 4.53,-5.25 6.66,5.25 z",
    fill: "#ffffff",
    id: "path3246"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m 332.30862,735.5162 -6.66,-5.26 4.52,-5.25 6.66,5.25 z",
    fill: "#ffffff",
    id: "path3248"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m 634.07062,350.9962 h -67 v 86 h 67 z",
    fill: "#61656d",
    id: "path3250"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 634.07062,350.9962 h -14 v 86 h 14 z",
    fill: "#000000",
    id: "path3252"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m 178.92862,359.7062 c 0,0 13.22,1.81 74,0.55 16.43,10 87.67,3.63 115.75,1 32.45,6 48.5,-9.7 34.09,-18.18 -4.44,-2.63 -11.78,-4.57 -22.45,-5 0.69,-33.78 -82.87,-44.86 -106.16,4.44 -12.32,-10 -38,-9.06 -39.72,4.44 -23.78,-4.36 -42.57,0.56 -51.16,5.72 -4.54,2.72 -6.23,5.5 -4.35,7.03 z",
    fill: "#ffffff",
    id: "path3254"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "m 178.92962,359.7062 c 0,0 13.22,1.81 74,0.55 16.43,10 87.67,3.63 115.75,1 32.45,6 48.5,-9.7 34.09,-18.18 0.109,2.111 -0.608,4.181 -2,5.77 -3.3,3.77 -9.5,5.33 -15.17,4.85 -5.67,-0.48 -10.88,-2.7 -15.62,-5.25 -2.27,-1.23 -4.59,-2.58 -7.3,-2.84 -4.8,-0.47 -9,2.57 -12.34,5.38 -2.79,-4.51 -9.85,-7 -15.79,-5.46 -5.94,1.54 -10.07,6.74 -9.21,11.73 -11.62,-2.07 -23.48,3.48 -35.32,2.6 -13.53,-1 -25.71,-10.29 -39,-7.93 -3.36,0.59 -6.46,1.91 -9.82,2.47 -3.346,0.391 -6.719,0.481 -10.08,0.27 -10.82,-0.2 -21.65,1.19 -32.46,0.64 -5.229,-0.218 -10.409,-1.092 -15.42,-2.6 -4.5,2.69 -6.19,5.47 -4.31,7 z",
    fill: "#21252b",
    id: "path3256"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m 357.07062,233.9962 c 32.033,0 58,-25.967 58,-58 0,-32.032 -25.967,-58 -58,-58 -32.033,0 -58,25.968 -58,58 0,32.033 25.967,58 58,58 z",
    fill: "#ffffff",
    id: "path3258"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m 958.39062,558.7262 c 0,0.09 0,0.39 0.1,0.76 0.07,0.408 0.02,0.829 -0.15,1.209 -0.16,0.381 -0.43,0.704 -0.78,0.931 -0.28,0.173 -0.51,0.411 -0.67,0.693 -0.17,0.282 -0.26,0.6 -0.27,0.927 -0.01,0.254 0.03,0.509 0.12,0.748 0.09,0.238 0.22,0.457 0.39,0.644 0.18,0.186 0.39,0.335 0.62,0.44 0.23,0.104 0.48,0.161 0.74,0.168 h 2.12 c 0.26,0 0.51,-0.17 0.5,-0.43 -0.01,-0.26 -0.18,-0.52 -0.44,-0.5 0,-0.05 -2.1,-10.05 -2.28,-5.59 z",
    fill: "#fc9d9d",
    id: "path3260"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m 982.06062,685.7862 c 0,-0.335 -0.1,-0.662 -0.29,-0.94 -0.18,-0.278 -0.45,-0.495 -0.76,-0.622 -0.31,-0.128 -0.65,-0.161 -0.97,-0.095 -0.33,0.066 -0.63,0.228 -0.87,0.465 -0.24,0.238 -0.4,0.54 -0.46,0.868 -0.06,0.329 -0.03,0.669 0.1,0.978 0.13,0.308 0.35,0.571 0.63,0.756 0.28,0.184 0.6,0.282 0.94,0.28 0.45,-0.003 0.87,-0.182 1.19,-0.499 0.31,-0.316 0.49,-0.745 0.49,-1.191 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3262"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m 993.90062,876.2862 h 16.68998 l 0.43,9.6 c 0.05,1.24 0.38,2.45 0.97,3.54 0.59,1.09 1.42,2.03 2.43,2.75 l 12.25,8.75 -30.68998,-0.76 z",
    fill: "#fb9c9c",
    id: "path3264"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 1004.8706,896.2462 4.4,1.75 -13.37998,1.47 -1.47,-16.27 h 16.35998 l 0.1,1.94 -9.79,1.42 c -0.51,0.07 -0.97,0.34 -1.28998,0.75 -0.31,0.4 -0.46,0.92 -0.41,1.43 v 0.18 c 0.15,1.61 0.73998,3.15 1.70998,4.44 0.96,1.29 2.27,2.29 3.77,2.89 z",
    fill: "#000000",
    id: "path3266"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m 995.65062,893.3662 6.52998,2 c 0.47,0.15 0.96,0.17 1.44,0.07 0.48,-0.1 0.93,-0.32 1.3,-0.64 l 5.15,-4.4 c 0.56,-0.48 1.28,-0.75 2.02,-0.77 0.74,-0.02 1.46,0.22 2.05,0.67 l 11.63,9 9.18,3 c 1.32,0.44 2.47,1.28 3.28,2.41 0.81,1.13 1.26,2.48 1.26,3.87 0,0.39 -0.16,0.76 -0.43,1.04 -0.28,0.28 -0.65,0.43 -1.04,0.43 h -40.65998 c -0.46,0 -0.92,-0.09 -1.34,-0.26 -0.43,-0.18 -0.82,-0.43 -1.14,-0.76 -0.33,-0.32 -0.58,-0.71 -0.76,-1.14 -0.17,-0.42 -0.26,-0.88 -0.26,-1.34 v -12 c 0.02,-0.2 0.09,-0.4 0.19,-0.57 0.11,-0.18 0.26,-0.33 0.43,-0.44 0.17,-0.11 0.36,-0.19 0.56,-0.22 0.21,-0.03 0.41,-0.01 0.61,0.05 z",
    fill: "#3f4249",
    id: "path3268"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m 957.57062,876.2862 h -16.7 l -0.43,9.6 c -0.05,1.24 -0.39,2.45 -0.98,3.54 -0.59,1.09 -1.41,2.03 -2.42,2.75 l -12.25,8.75 30.69,-0.76 z",
    fill: "#fb9c9c",
    id: "path3270"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 946.57062,896.2462 -4.4,1.75 13.38,1.47 1.47,-16.27 h -16.36 l -0.1,1.94 9.79,1.42 c 0.51,0.07 0.97,0.34 1.29,0.75 0.32,0.4 0.46,0.92 0.41,1.43 v 0.18 c -0.14,1.61 -0.73,3.15 -1.7,4.44 -0.97,1.3 -2.27,2.3 -3.78,2.89 z",
    fill: "#000000",
    id: "path3272"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m 955.82062,893.3662 -6.53,2 c -0.47,0.15 -0.97,0.17 -1.45,0.07 -0.48,-0.1 -0.92,-0.32 -1.29,-0.64 l -5.15,-4.4 c -0.57,-0.48 -1.28,-0.75 -2.02,-0.77 -0.74,-0.02 -1.47,0.22 -2.05,0.67 l -11.63,9 -9.18,3 c -1.32,0.44 -2.47,1.28 -3.28,2.41 -0.82,1.13 -1.26,2.48 -1.26,3.87 0,0.39 0.15,0.76 0.43,1.04 0.27,0.28 0.65,0.43 1.04,0.43 h 40.67 c 0.46,0 0.91,-0.09 1.34,-0.26 0.42,-0.18 0.81,-0.44 1.13,-0.76 0.33,-0.33 0.59,-0.71 0.76,-1.14 0.18,-0.42 0.27,-0.88 0.27,-1.34 v -12 c -0.03,-0.2 -0.09,-0.4 -0.2,-0.58 -0.11,-0.17 -0.26,-0.32 -0.43,-0.43 -0.17,-0.11 -0.36,-0.19 -0.57,-0.22 -0.2,-0.03 -0.41,-0.01 -0.6,0.05 z",
    fill: "#3f4249",
    id: "path3274"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m 957.57062,907.1762 h -45.4 c -0.14,0.47 -0.21,0.97 -0.19,1.46 0,0.39 0.15,0.76 0.43,1.04 0.27,0.28 0.65,0.43 1.04,0.43 h 40.67 c 0.83,0 1.63,-0.29 2.26,-0.83 0.64,-0.53 1.06,-1.28 1.19,-2.1 z",
    fill: "#000000",
    id: "path3276"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m 937.28062,895.0162 -2.45,-2.65 c -0.04,-0.03 -0.06,-0.07 -0.08,-0.12 -0.02,-0.04 -0.03,-0.09 -0.03,-0.14 0,-0.05 0.01,-0.1 0.03,-0.14 0.02,-0.05 0.04,-0.09 0.08,-0.12 0.07,-0.07 0.16,-0.11 0.26,-0.11 0.1,0 0.19,0.04 0.26,0.11 l 2.46,2.65 c 0.07,0.07 0.11,0.16 0.11,0.26 0,0.1 -0.04,0.19 -0.11,0.26 -0.06,0.06 -0.15,0.1 -0.24,0.1 -0.1,-0.01 -0.2,-0.05 -0.29,-0.1 z",
    fill: "#ffffff",
    id: "path3278"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m 935.34062,896.5362 -2.46,-2.65 c -0.07,-0.07 -0.11,-0.16 -0.11,-0.26 0,-0.1 0.04,-0.19 0.11,-0.26 0.07,-0.07 0.17,-0.1 0.26,-0.1 0.1,0 0.2,0.03 0.27,0.1 l 2.46,2.65 c 0.07,0.07 0.11,0.16 0.11,0.26 0,0.1 -0.04,0.19 -0.11,0.26 -0.06,0.06 -0.15,0.1 -0.24,0.1 -0.1,-0.01 -0.2,-0.05 -0.29,-0.1 z",
    fill: "#ffffff",
    id: "path3280"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m 933.40062,898.0462 -2.46,-2.65 c -0.07,-0.07 -0.1,-0.16 -0.1,-0.26 0,-0.1 0.03,-0.19 0.1,-0.26 0.04,-0.04 0.08,-0.06 0.12,-0.08 0.05,-0.02 0.1,-0.03 0.15,-0.03 0.05,0 0.1,0.01 0.14,0.03 0.05,0.02 0.09,0.04 0.12,0.08 l 2.46,2.64 c 0.07,0.07 0.11,0.17 0.11,0.26 0,0.1 -0.04,0.2 -0.11,0.27 -0.06,0.06 -0.15,0.09 -0.24,0.09 -0.1,0.01 -0.21,-0.02 -0.29,-0.09 z",
    fill: "#ffffff",
    id: "path3282"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m 993.91062,907.1762 h 45.38998 c 0.14,0.47 0.21,0.97 0.19,1.46 0,0.39 -0.15,0.76 -0.43,1.04 -0.27,0.28 -0.65,0.43 -1.04,0.43 h -40.65998 c -0.83,0 -1.63,-0.29 -2.26,-0.83 -0.63,-0.54 -1.05,-1.28 -1.19,-2.1 z",
    fill: "#000000",
    id: "path3284"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m 967.40062,548.8652 17.67,11.13 3,25 -10.3,-0.39 -9.1,3.33 -1,-9.93 -1.4,-0.09 c -1.51,-0.095 -2.94,-0.713 -4.05,-1.747 -1.11,-1.034 -1.82,-2.421 -2.02,-3.923 l -2.82,-21.45 z",
    fill: "#fc9d9d",
    id: "path3286"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m 956.80062,543.5562 c 5.17,-2.626 11.02,-3.59 16.75,-2.76 l 6,0.65 c 3.08,0.34 2.55,-0.67 2.93,2.4 l 0.36,3 c 2.06,0.39 8.12,2.3 8.12,2.3 1.4,6.25 -0.07,11.88 -2.52,18.24 l -2.33,6.07 -5.18,0.13 c -1.01,0.227 -2.08,0.082 -3,-0.41 -0.91,-0.492 -1.62,-1.298 -2,-2.27 l -3.61,-8.39 -4,-2.29 -0.39,2 c -0.03,0.293 -0.18,0.563 -0.4,0.755 -0.22,0.193 -0.51,0.295 -0.8,0.287 -0.3,-0.009 -0.58,-0.128 -0.79,-0.334 -0.21,-0.206 -0.34,-0.484 -0.36,-0.778 l -0.09,-2.81 v -0.73 c 0,-0.133 -0.05,-0.261 -0.14,-0.36 -0.08,-0.099 -0.21,-0.163 -0.34,-0.18 -0.95,-0.027 -1.87,-0.38 -2.6,-1 -0.73,-0.62 -1.22,-1.471 -1.4,-2.41 -0.17,-0.656 -0.51,-1.257 -0.98,-1.746 -0.46,-0.49 -1.05,-0.853 -1.7,-1.054 l -1.39,-0.43 c -3.21,-1 -1.93,-3.29 -1.9,-6.66 0.05,-0.05 -0.83,0.05 1.76,-1.22 z",
    fill: "#21252b",
    id: "path3288"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m 1014.1906,895.0162 2.46,-2.65 c 0.07,-0.07 0.11,-0.16 0.11,-0.26 0,-0.1 -0.04,-0.19 -0.11,-0.26 -0.07,-0.07 -0.17,-0.1 -0.26,-0.1 -0.1,0 -0.2,0.03 -0.27,0.1 l -2.46,2.65 c -0.07,0.07 -0.11,0.16 -0.11,0.26 0,0.1 0.04,0.19 0.11,0.26 0.07,0.06 0.15,0.1 0.24,0.1 0.1,-0.01 0.2,-0.04 0.29,-0.1 z",
    fill: "#ffffff",
    id: "path3290"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m 1016.1306,896.5362 2.46,-2.65 c 0.07,-0.07 0.11,-0.16 0.11,-0.26 0,-0.1 -0.04,-0.19 -0.11,-0.26 -0.07,-0.07 -0.16,-0.1 -0.26,-0.1 -0.1,0 -0.19,0.03 -0.27,0.1 l -2.46,2.65 c -0.05,0.05 -0.08,0.11 -0.1,0.18 -0.01,0.07 -0.01,0.14 0.02,0.21 0.02,0.07 0.07,0.12 0.12,0.16 0.06,0.05 0.13,0.07 0.2,0.07 0.11,-0.01 0.2,-0.05 0.29,-0.1 z",
    fill: "#ffffff",
    id: "path3292"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m 1018.0706,898.0462 2.46,-2.65 c 0.07,-0.07 0.11,-0.16 0.11,-0.26 0,-0.1 -0.04,-0.19 -0.11,-0.26 -0.03,-0.04 -0.07,-0.06 -0.12,-0.08 -0.05,-0.02 -0.09,-0.03 -0.14,-0.03 -0.05,0 -0.1,0.01 -0.15,0.03 -0.04,0.02 -0.08,0.04 -0.12,0.08 l -2.46,2.64 c -0.07,0.07 -0.1,0.17 -0.1,0.26 0,0.1 0.03,0.2 0.1,0.27 0.07,0.06 0.15,0.09 0.24,0.09 0.11,0.01 0.21,-0.02 0.29,-0.09 z",
    fill: "#ffffff",
    id: "path3294"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m 1005.3906,693.2862 6.18,189.89 h -17.89998 l -16.6,-155.7 c -0.09,-0.452 -0.34,-0.859 -0.69,-1.151 -0.36,-0.291 -0.81,-0.451 -1.27,-0.451 -0.46,0 -0.91,0.16 -1.27,0.451 -0.35,0.292 -0.6,0.699 -0.69,1.151 l -15.58,155.7 h -17.93 v -191 z",
    fill: "#3f4249",
    id: "path3296"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 939.20062,879.2762 8.08,-0.05 -0.19,4 h -7.94 z",
    fill: "#000000",
    id: "path3298"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m 956.99062,551.3872 15.37,3 c 0.49,0.069 0.96,0.238 1.39,0.496 0.42,0.259 0.79,0.601 1.08,1.007 0.28,0.405 0.49,0.865 0.59,1.351 0.1,0.486 0.11,0.988 0.01,1.476 0,0 17.7,-1.27 15.42,-10.32 -1.27,-5.16 -6.11,-7.43 -8.52,-8 -0.38,-0.081 -0.73,-0.247 -1.02,-0.487 -0.3,-0.24 -0.54,-0.545 -0.7,-0.893 -0.83,-1.68 -2.89,-4.81 -8.16,-5 -4,-0.23 -6.07,2.35 -7.32,4 -0.82,1 0.11,1.38 -0.94,0.8 -1.06,-0.414 -2.2,-0.558 -3.33,-0.42 -1.12,0.138 -2.2,0.553 -3.12,1.21 -4.69,3 -5.72,10.77 -0.75,11.78 z",
    fill: "#21252b",
    id: "path3300"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 973.37062,564.6062 -3.61,-0.87 c 0.9,-0.361 1.78,-0.779 2.63,-1.25 l 0.11,-0.72 z",
    fill: "#000000",
    id: "path3302"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m 968.65062,557.1752 c 0.06,-0.332 0.2,-0.647 0.39,-0.923 0.2,-0.275 0.46,-0.504 0.75,-0.669 0.3,-0.166 0.62,-0.266 0.96,-0.291 0.34,-0.026 0.68,0.023 0.99,0.143 3,0.86 3.38,7.32 -1.36,8.35 -2.49,0.53 -2.2,-1 -2.06,-3 z",
    fill: "#fc9d9d",
    id: "path3304"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 969.57062,560.3552 c 0,0.17 0.13,0.33 0.3,0.3 0.17,-0.03 0.32,-0.13 0.3,-0.3 v -0.6 c -0.05,-0.507 0.02,-1.02 0.22,-1.49 0.2,-0.38 0.33,-0.65 0.59,-0.69 0.16,-0.061 0.33,-0.082 0.49,-0.061 0.17,0.021 0.33,0.083 0.46,0.181 0.18,0.06 0.35,0 0.41,-0.14 0.02,-0.089 0.02,-0.183 0,-0.271 -0.03,-0.088 -0.08,-0.167 -0.15,-0.229 -0.21,-0.117 -0.44,-0.19 -0.68,-0.214 -0.25,-0.024 -0.49,0.001 -0.72,0.074 -0.43,0.214 -0.79,0.565 -1,1 -0.22,0.586 -0.31,1.216 -0.25,1.84 z",
    fill: "#000000",
    id: "path3306"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "m 956.94062,562.3172 c -0.06,0.002 -0.13,-0.008 -0.19,-0.032 -0.07,-0.023 -0.12,-0.058 -0.17,-0.104 -0.05,-0.046 -0.09,-0.101 -0.12,-0.161 -0.02,-0.061 -0.04,-0.127 -0.04,-0.193 v -7.57 c 0,-0.067 0.01,-0.133 0.03,-0.196 0.03,-0.062 0.06,-0.119 0.11,-0.167 0.04,-0.049 0.1,-0.088 0.16,-0.115 0.06,-0.027 0.13,-0.041 0.19,-0.042 0.07,-0.002 0.14,0.01 0.2,0.035 0.06,0.024 0.12,0.06 0.17,0.107 0.04,0.046 0.08,0.102 0.11,0.163 0.03,0.062 0.04,0.128 0.04,0.195 l 0.06,7.56 c 0,0.116 -0.03,0.23 -0.1,0.322 -0.08,0.092 -0.18,0.159 -0.29,0.188 -0.05,0.023 -0.11,0.027 -0.16,0.01 z",
    fill: "#21252b",
    id: "path3308"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "m 956.94062,558.1072 11.7,-0.12 v -1 l -11.7,0.12 z",
    fill: "#21252b",
    id: "path3310"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 968.29062,584.3762 5,-1.09 0.63,-4.3 c 0.05,-0.288 0.03,-0.584 -0.07,-0.86 -0.09,-0.277 -0.25,-0.525 -0.47,-0.724 -0.21,-0.198 -0.47,-0.34 -0.76,-0.413 -0.28,-0.072 -0.58,-0.074 -0.86,-0.003 l -4.09,1 z",
    fill: "#000000",
    id: "path3312"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 993.57062,883.3862 -16.5,-155.859 c -0.05,-0.485 -0.27,-0.936 -0.63,-1.267 -0.35,-0.331 -0.82,-0.521 -1.31,-0.533 h 2.22 c 2.3,0.005 4.51,0.85 6.23,2.375 1.72,1.525 2.82,3.625 3.09,5.905 l 17.38998,148.999 z",
    fill: "#000000",
    id: "path3314"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m 858.23062,623.4072 -4.49,-0.909 -5.44,26.915 4.48,0.908 z",
    fill: "#61656d",
    id: "path3316"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "m 861.26062,617.3572 c -0.59,1.73 -1.91,3.27 -3.73,3.11 -2.44,-0.21 -3.2,-2.23 -2.73,-4.57 l 0.12,-0.6 c 0.17,-0.82 -1.8,-1 -2.38,-0.43 -0.81,0.828 -1.39,1.855 -1.68,2.978 -0.29,1.122 -0.27,2.301 0.04,3.417 0.31,1.116 0.91,2.131 1.74,2.941 0.83,0.81 1.86,1.388 2.98,1.675 1.12,0.287 2.3,0.273 3.42,-0.04 1.11,-0.313 2.13,-0.914 2.94,-1.744 0.81,-0.829 1.39,-1.857 1.67,-2.98 0.29,-1.123 0.27,-2.302 -0.04,-3.417 -0.27,-0.93 -2.04,-1.28 -2.35,-0.34 z",
    fill: "#61656d",
    id: "path3318"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m 844.86062,656.8162 c 0.58,-1.73 1.9,-3.27 3.73,-3.11 2.44,0.22 3.2,2.23 2.73,4.57 0,0 -0.13,0.59 -0.13,0.6 -0.17,0.82 1.8,1 2.39,0.44 0.72,-0.733 1.25,-1.622 1.57,-2.598 0.31,-0.976 0.39,-2.012 0.24,-3.025 -0.16,-1.014 -0.54,-1.977 -1.14,-2.814 -0.59,-0.838 -1.37,-1.526 -2.27,-2.01 -0.9,-0.485 -1.91,-0.752 -2.93,-0.782 -1.03,-0.03 -2.05,0.179 -2.98,0.611 -0.93,0.431 -1.74,1.073 -2.38,1.875 -0.64,0.801 -1.09,1.741 -1.3,2.743 -0.21,1.032 -0.17,2.099 0.12,3.11 0.28,0.98 2.06,1.34 2.35,0.39 z",
    fill: "#61656d",
    id: "path3320"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m 857.14062,634.0452 8.71,9.18 c 0,0 -10,2.47 -14.15,1.3 -4.15,-1.17 -3.4,-3.36 -3.4,-3.36 z",
    fill: "#fc9d9d",
    id: "path3322"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m 846.01062,632.3662 c 0.01,-0.164 0.05,-0.325 0.12,-0.473 0.07,-0.148 0.18,-0.279 0.3,-0.386 0.13,-0.106 0.27,-0.186 0.43,-0.235 0.16,-0.048 0.32,-0.064 0.49,-0.046 l 8.64,0.69 c 0.1,0.025 0.21,0.007 0.31,-0.05 0.09,-0.057 0.16,-0.149 0.18,-0.255 0.03,-0.106 0.01,-0.218 -0.05,-0.311 -0.06,-0.092 -0.15,-0.159 -0.25,-0.184 l -3.94,-1.5 c -0.5,-0.324 -0.87,-0.809 -1.05,-1.373 -0.18,-0.564 -0.17,-1.174 0.05,-1.727 v 0 c 0.07,-0.192 0.22,-0.349 0.4,-0.438 0.19,-0.089 0.4,-0.104 0.6,-0.042 l 5.36,1.1 c 1.83,0.371 3.58,1.079 5.16,2.09 l 3.58,2.29 14.31,5.84 -1.62,9.66 -13.21,-3.77 c 0,0 -11.67,-0.17 -15.81,-1.35 -4.14,-1.18 -3.26,-4.22 -3.26,-4.22 -2.76,-2 -0.22,-3.55 -0.22,-3.55 -0.46,-0.13 -0.52,-1.76 -0.52,-1.76 z",
    fill: "#fc9d9d",
    id: "path3324"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    id: "g3328",
    transform: "translate(-224.42938,-142.8238)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 1076.64,781.309 -5.45,-0.54 c -0.08,-0.01 -0.15,-0.05 -0.2,-0.111 -0.04,-0.062 -0.07,-0.14 -0.06,-0.219 0.01,-0.038 0.02,-0.075 0.03,-0.109 0.02,-0.033 0.05,-0.063 0.08,-0.087 0.03,-0.025 0.06,-0.043 0.1,-0.053 0.03,-0.011 0.07,-0.015 0.11,-0.011 l 5.44,0.55 c 0.08,0.008 0.15,0.046 0.2,0.106 0.05,0.059 0.08,0.136 0.07,0.214 -0.02,0.081 -0.06,0.155 -0.12,0.21 -0.06,0.041 -0.13,0.059 -0.2,0.05 z",
    fill: "#000000",
    id: "path3326"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    id: "g3332",
    transform: "translate(-224.42938,-142.8238)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 1078.19,784.739 -5.44,-0.54 c -0.07,-0.012 -0.13,-0.049 -0.17,-0.103 -0.05,-0.054 -0.07,-0.121 -0.07,-0.192 0,-0.07 0.02,-0.138 0.07,-0.191 0.04,-0.054 0.1,-0.091 0.17,-0.104 l 5.45,0.55 c 0.04,0.004 0.08,0.015 0.11,0.034 0.04,0.018 0.07,0.042 0.09,0.072 0.02,0.03 0.04,0.064 0.05,0.101 0.01,0.037 0.02,0.075 0.01,0.113 -0.01,0.083 -0.05,0.159 -0.12,0.21 -0.04,0.031 -0.09,0.048 -0.15,0.05 z",
    fill: "#000000",
    id: "path3330"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    id: "g3336",
    transform: "translate(-224.42938,-142.8238)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 1076.35,777.871 -5.44,-0.55 c -0.08,-0.01 -0.15,-0.049 -0.2,-0.108 -0.05,-0.059 -0.07,-0.135 -0.07,-0.212 0.01,-0.078 0.05,-0.148 0.11,-0.198 0.07,-0.05 0.14,-0.076 0.22,-0.072 l 5.44,0.55 c 0.04,0.004 0.08,0.015 0.11,0.033 0.03,0.018 0.06,0.043 0.09,0.073 0.02,0.029 0.04,0.064 0.05,0.1 0.01,0.037 0.02,0.076 0.01,0.114 -0.01,0.083 -0.05,0.158 -0.12,0.21 -0.06,0.04 -0.13,0.061 -0.2,0.06 z",
    fill: "#000000",
    id: "path3334"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 849.00062,643.1762 c 3.61,1.1 8.13,0.31 11.72,-0.87 l 4,-1.23 c 0.45,-0.15 0.93,-0.15 1.38,0 l 5,1.75 -0.54,2.06 -4.71,-1.65 c 0,0 -10,2.48 -14.15,1.3 -2.32,-0.79 -2.7,-1.36 -2.7,-1.36 z",
    fill: "#000000",
    id: "path3338"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "m 866.07062,643.9962 3,-12 43,5 21.83,-41.56 c 3.01,-3.238 7.06,-5.319 11.45,-5.88 l 20.22,-2.48 1.74,-2.87 c 0.11,-0.19 0.27,-0.347 0.47,-0.456 0.19,-0.109 0.41,-0.165 0.63,-0.164 h 20.09 c 0.24,-0.002 0.47,0.062 0.67,0.184 0.2,0.122 0.36,0.297 0.47,0.506 l 1.69,3.21 18.32998,3.52 c 2.7,0.513 5.19,1.81 7.16,3.729 1.97,1.919 3.33,4.375 3.91,7.061 l 12.15,55.74 c 0.25,1.145 0.24,2.331 -0.03,3.471 -0.27,1.14 -0.79,2.205 -1.52,3.117 -0.74,0.912 -1.67,1.648 -2.73,2.154 -1.05,0.506 -2.21,0.768 -3.38,0.768 h -17.31 l -2.46,27.53 h -65.80998 v -69.56 l -15.16,27.71 c -0.91,1.661 -2.35,2.969 -4.09,3.712 -1.74,0.744 -3.68,0.881 -5.51,0.388 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3340"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 866.07062,643.9962 3,-12 43,5 21.83,-41.56 c 3.01,-3.238 7.06,-5.319 11.45,-5.88 l 20.22,-2.48 1.74,-2.87 c 0.11,-0.19 0.27,-0.347 0.47,-0.456 0.19,-0.109 0.41,-0.165 0.63,-0.164 h 20.09 c 0.24,-0.002 0.47,0.062 0.67,0.184 0.2,0.122 0.36,0.297 0.47,0.506 l 1.69,3.21 18.32998,3.52 c 2.7,0.513 5.19,1.81 7.16,3.729 1.97,1.919 3.33,4.375 3.91,7.061 l 12.15,55.74 c 0.25,1.145 0.24,2.331 -0.03,3.471 -0.27,1.14 -0.79,2.205 -1.52,3.117 -0.74,0.912 -1.67,1.648 -2.73,2.154 -1.05,0.506 -2.21,0.768 -3.38,0.768 h -17.31 l -2.46,27.53 h -65.80998 v -69.56 l -15.16,27.71 c -0.91,1.661 -2.35,2.969 -4.09,3.712 -1.74,0.744 -3.68,0.881 -5.51,0.388 z",
    fill: "#000000",
    id: "path3342"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 1004.9206,694.4472 0.76,0.06 6.13,-69.45 -0.76,-0.07 z",
    fill: "#000000",
    id: "path3344"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 1012.8106,655.0062 h -3.83 l 2.43,-30 3.61,27.42 c 0.05,0.319 0.02,0.645 -0.06,0.955 -0.09,0.31 -0.25,0.597 -0.46,0.842 -0.21,0.245 -0.47,0.442 -0.76,0.577 -0.29,0.135 -0.61,0.205 -0.93,0.206 z",
    fill: "#000000",
    id: "path3346"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 965.57062,587.4562 h 20.47 v -0.76 h -20.47 z",
    fill: "#000000",
    id: "path3348"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m 959.00062,587.9062 5.55,46.111 h 29.17 l 5.07,-45 4.86998,0.829 -2.39,41.46 c -0.1,1.777 0.17,3.556 0.8,5.22 l 7,18.541 -3.42,39.839 h -65.99998 v -39.899 l 13.17,-17 c 1.79,-2.312 2.72,-5.169 2.65,-8.091 l -1,-41.42 z",
    fill: "#3f4249",
    id: "path3350"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 949.41062,696.6462 v -3.06 h -0.17 l -3.37,-77.51 -6.26,9.06 v 68.45 185.59 h 7.71 l 2.13,-182 z",
    fill: "#000000",
    id: "path3352"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 967.54062,690.3652 h -2.85 v 9.68 h 2.85 z",
    fill: "#000000",
    id: "path3354"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 993.72062,690.3652 h -2.85 v 9.68 h 2.85 z",
    fill: "#000000",
    id: "path3356"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 914.88062,656.8252 c 1.83,0.493 3.77,0.356 5.51,-0.387 1.74,-0.744 3.18,-2.052 4.09,-3.713 l 1.33,-2.43 c -3.26,5.29 -13.74,1.7 -13.74,1.7 l -45.07,-11.71 -0.93,3.71 z",
    fill: "#000000",
    id: "path3358"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m 851.91062,631.3862 1.34,-6.61 4.33,1.71 -0.99,4.9 z",
    fill: "#61656d",
    id: "path3360"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 989.30062,566.2862 c 3.52,-6.22 4,-8.43 4.48,-14.75 l -18.5,-8.68 -7.94,6.05 c 2.17,3.57 3.12,4.19 7.3,4.74 2.82,0.38 4.13,-0.27 5.67,0.48",
    fill: "#b2b6bb",
    id: "path3362"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 997.36062,557.3862 1,-4.08 c 0.55,-1.9 0,-2 -1.62,-2.65 0.94,-15.64 -7.4,-22.77 -18.41,-23.56 -11.89,-0.85 -15.83,4.07 -20.21,9.74 -5.38,7 -3.64,6.46 -12.28,8.77 -0.86,1.61 3.65,2.64 9.21,3.78 4.4,0.89 9.28,1.93 11.84,1.72 8.67,-0.7 16,-0.62 22.25,6.47 l 5.61,0.92 c 1.97,0.39 2.31,0.18 2.61,-1.11 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3364"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 997.36062,557.3862 1,-4.08 c 0.55,-1.9 0,-2 -1.62,-2.65 0.94,-15.64 -7.4,-22.77 -18.41,-23.56 l -1.24,-0.07 c 8.94,3.81 12.59,9.86 11,20.61 -11.23,-2.38 -22.11,-4.68 -33.51,-5.31 9.56,1.79 26.83,4.81 31.14,7 1.53,0.79 0.86,1.84 0.67,3.51 l -0.47,1.69 c 1.18,0.883 2.26,1.889 3.23,3 l 5.61,0.92 c 1.96,0.44 2.3,0.23 2.6,-1.06 z",
    fill: "#000000",
    id: "path3366"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m 140.06062,283.1152 c 32.696,3.845 65.589,5.771 98.51,5.77 18.667,0 37.297,-0.623 55.89,-1.87 63.378,-4.212 126.026,-15.982 186.61,-35.06 l -0.56,-1.91 c -135.4,42.81 -259.72,40.54 -340.17,31.13 -28.296,-3.3 -56.397,-8.11 -84.18,-14.41 l -1.27,1.76 c 28.107,6.39 56.539,11.261 85.17,14.59 z",
    fill: "#61656d",
    id: "path3368"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m 475.20062,284.8852 c -32.868,10e-4 -65.708,-1.926 -98.35,-5.77 -87.28,-10.27 -143.22,-30.94 -143.78,-31.18 l 0.65,-1.88 c 0.56,0.21 56.35,20.84 143.41,31.08 80.34,9.45 204.47,11.72 339.67,-31.09 l 0.56,1.91 c -60.499,19.079 -123.064,30.85 -186.36,35.06 -18.507,1.253 -37.107,1.877 -55.8,1.87 z",
    fill: "#61656d",
    id: "path3370"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m 1129.0006,261.5572 c -109.71,26.52 -208.18998,23.7 -275.23998,15.58 -84.579,-10.23 -138.789,-30.86 -139.329,-31.07 l -0.72,1.87 c 0.54,0.21 54.93,20.91 139.739,31.18 31.72,3.843 63.63,5.77 95.58,5.77 18.14,0 36.22,-0.624 54.23998,-1.87 42.55,-2.947 84.78,-9.47 126.24,-19.5 z",
    fill: "#61656d",
    id: "path3372"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m 712.02762,288.8852 c -32.086,10e-4 -64.144,-1.925 -96,-5.77 -85.17,-10.27 -139.8,-31 -140.34,-31.18 l 0.72,-1.87 c 0.54,0.21 55,20.84 139.92,31.07 78.38,9.45 199.513,11.72 331.413,-31.09 l 0.62,1.91 c -58.97,19.06 -120.05,30.834 -181.883,35.06 -18.053,1.253 -36.203,1.877 -54.45,1.87 z",
    fill: "#61656d",
    id: "path3374"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m 576.49762,404.7362 c -0.273,0.046 -0.554,0.006 -0.805,-0.112 -0.251,-0.119 -0.459,-0.311 -0.597,-0.552 -0.139,-0.24 -0.2,-0.517 -0.176,-0.794 0.023,-0.276 0.131,-0.539 0.308,-0.752 l 16.54,-28.35 c 0.097,-0.26 0.271,-0.485 0.499,-0.643 0.228,-0.159 0.499,-0.244 0.776,-0.244 0.278,0 0.549,0.085 0.777,0.244 0.228,0.158 0.402,0.383 0.498,0.643 l 16.3,28.5 c 0.175,0.214 0.28,0.477 0.301,0.753 0.022,0.275 -0.041,0.551 -0.18,0.79 -0.139,0.239 -0.347,0.43 -0.598,0.547 -0.25,0.118 -0.53,0.156 -0.803,0.11 z",
    fill: "#f4f4f4",
    id: "path3376"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m 607.50662,401.3852 -13.67,-23.9 c -0.055,-0.172 -0.162,-0.322 -0.308,-0.428 -0.146,-0.107 -0.321,-0.164 -0.502,-0.164 -0.18,0 -0.356,0.057 -0.502,0.164 -0.145,0.106 -0.253,0.256 -0.308,0.428 l -13.86,23.78 c -0.46,0.77 -0.1,1.41 0.8,1.42 l 27.53,0.11 c 0.88,0 1.27,-0.62 0.82,-1.41 z m -26.77,-0.54 12.28,-21.08 12.11,21.18 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3378"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "m 593.53062,385.9652 -4.28,7.53 3.51,0.02 -1.53,6.24 4.84,-7.87 -3.74,-0.01 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3380"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m 566.21762,691.1752 c 0.62,1.36 1.23,2.73 1.84,4.1 0.026,0.04 0.061,0.073 0.103,0.096 0.042,0.023 0.089,0.035 0.137,0.034 h 2.49 c 0.87,0 1.95,-0.18 2,1 0,0.35 0.56,0.35 0.54,0 -0.17,-2.18 -2.9,-1.58 -4.41,-1.58 h -0.53 c -0.3,0 0.14,0.25 0,0 l -0.62,-1.38 -1.17,-2.63 c -0.14,-0.31 -0.61,0 -0.47,0.28",
    fill: "#21252b",
    id: "path3382"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m 568.30262,694.8362 c -1.41,0 -3.71,-0.45 -3.81,1.58 0,0.35 0.52,0.35 0.54,0 0,-0.77 0.54,-1 1.22,-1 h 2.05 c 0.061,-0.012 0.117,-0.045 0.157,-0.094 0.039,-0.048 0.061,-0.109 0.061,-0.171 0,-0.063 -0.022,-0.124 -0.061,-0.172 -0.04,-0.048 -0.096,-0.081 -0.157,-0.093",
    fill: "#21252b",
    id: "path3384"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m 552.39062,684.1752 c 0,0 9.73,-8.9 13,-12.47 3.27,-3.57 7.4,-5.57 11.48,-4.41 4.08,1.16 6.73,5.65 5.32,11.31 -1.41,5.66 -8,14 -16.8,13.55 -8.8,-0.45 -11.72,-6.32 -13,-8",
    fill: "#dadddf",
    id: "path3386"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    id: "g3392",
    transform: "translate(-224.42938,-142.8238)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    id: "g3390"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 776.82,826.999 c 0,0 9.73,-8.9 13,-12.47 3.27,-3.57 7.4,-5.57 11.48,-4.41 4.08,1.16 6.73,5.65 5.32,11.31 -1.41,5.66 -8,14 -16.8,13.55 -8.8,-0.45 -11.72,-6.32 -13,-8",
    fill: "#000000",
    id: "path3388"
  })))), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m 555.38262,688.0552 c 0.614,0.432 1.322,0.71 2.065,0.811 0.743,0.101 1.499,0.021 2.206,-0.231 0,0 -1.28,1.42 1,1.71 2.28,0.29 7,-1.57 7,-1.57 0,0 -1.111,1.7 0.579,1.6 1.69,-0.1 5.221,-2.05 8.121,-5 2.9,-2.95 7,-7.72 4.41,-13.32 -2.06,-4.49 -8.62,-7.41 -18,3.06 z",
    fill: "#dadddf",
    id: "path3394"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m 576.83862,667.3062 c -4.08,-1.17 -8.23,0.83 -11.48,4.41 -1.15,1.27 -3.14,3.22 -5.21,5.21 l 2.24,2.24 4.13,-3.11 c 0,0 0,-3.32 2.76,-3.59 4,-0.4 3.41,7.83 13.25,3.52 0.15,-4.38 -2.27,-7.7 -5.69,-8.68",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3396"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    id: "g3402",
    transform: "translate(-224.42938,-142.8238)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    id: "g3400"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 801.268,810.13 c -4.08,-1.17 -8.23,0.83 -11.48,4.41 -1.15,1.27 -3.14,3.22 -5.21,5.21 l 2.24,2.24 4.13,-3.11 c 0,0 0,-3.32 2.76,-3.59 4,-0.4 3.41,7.83 13.25,3.52 0.15,-4.38 -2.27,-7.7 -5.69,-8.68",
    fill: "#000000",
    id: "path3398"
  })))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m 578.50362,674.1762 c 0,0.263 -0.078,0.52 -0.224,0.739 -0.146,0.219 -0.354,0.389 -0.597,0.49 -0.243,0.1 -0.51,0.127 -0.768,0.075 -0.258,-0.051 -0.495,-0.178 -0.681,-0.364 -0.186,-0.186 -0.313,-0.423 -0.364,-0.681 -0.051,-0.258 -0.025,-0.525 0.076,-0.768 0.1,-0.243 0.271,-0.451 0.49,-0.597 0.218,-0.146 0.475,-0.224 0.738,-0.224 0.352,0.003 0.689,0.144 0.938,0.392 0.249,0.249 0.39,0.586 0.392,0.938 z",
    fill: "#000000",
    id: "path3404"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m 582.23862,673.1762 c 0,0 2.77,1.37 2.83,1.93 0.06,0.56 -2.67,2.38 -2.67,2.38 0,0 -1.24,-2.63 -0.16,-4.31",
    fill: "#3f4249",
    id: "path3406"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m 564.96162,691.5542 1.84,4.11 c 0.025,0.039 0.058,0.072 0.099,0.094 0.04,0.023 0.085,0.035 0.131,0.036 h 2.54 c 0.87,0 1.95,-0.19 2,1 0,0.34 0.56,0.35 0.53,0 -0.16,-2.18 -2.89,-1.59 -4.4,-1.59 h -0.54 c -0.29,0 0.15,0.25 0,0 l -0.62,-1.38 -1.17,-2.62 c -0.15,-0.32 -0.61,0 -0.47,0.27",
    fill: "#21252b",
    id: "path3408"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "m 567.02662,695.2552 c -1.41,0 -3.71,-0.45 -3.8,1.59 0,0.35 0.52,0.35 0.53,0 0,-0.77 0.55,-1 1.23,-1 h 2 c 0.072,0 0.141,-0.028 0.191,-0.079 0.051,-0.05 0.079,-0.119 0.079,-0.191 0,-0.071 -0.028,-0.14 -0.079,-0.191 -0.05,-0.05 -0.119,-0.079 -0.191,-0.079",
    fill: "#21252b",
    id: "path3410"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "m 547.07062,686.9252 c 0,0 11.5,-9.75 14.5,-11.32 3,-1.57 7.71,-1.14 8.92,3 1.33,4.57 -3.23,12.72 -16.08,8.31 l -3.88,6.07 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3412"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    id: "g3418",
    transform: "translate(-224.42938,-142.8238)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    id: "g3416"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 779.477,826.76 c 0,0 0.65,1.11 4,-1.58 0,0 -1.43,1.89 -0.27,2.19 1.16,0.3 4.3,-1.94 4.3,-1.94 0,0 -1.59,1.59 -0.25,2.05 1.34,0.46 3.55,-1.5 4.05,-2.65 0.5,-1.15 1.61,-3.86 -0.58,-5.07 -2.19,-1.21 -6,0.21 -8.56,2.3 -2.56,2.09 -3.34,3.45 -2.71,4.7",
    fill: "#ffffff",
    id: "path3414"
  })))), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m 577.81362,674.0252 c 0,0.074 -0.03,0.145 -0.082,0.198 -0.053,0.052 -0.124,0.082 -0.198,0.082 -0.066,-0.013 -0.127,-0.048 -0.17,-0.1 -0.043,-0.052 -0.066,-0.118 -0.066,-0.185 0,-0.068 0.023,-0.134 0.066,-0.186 0.043,-0.052 0.104,-0.087 0.17,-0.099 0.038,0 0.075,0.007 0.109,0.022 0.035,0.015 0.066,0.036 0.093,0.063 0.026,0.027 0.046,0.059 0.06,0.094 0.013,0.035 0.019,0.073 0.018,0.111",
    fill: "#ffffff",
    id: "path3420"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m 298.65362,696.7962 c 0.325,0.002 0.644,-0.093 0.915,-0.272 0.271,-0.18 0.483,-0.436 0.608,-0.736 0.126,-0.3 0.159,-0.631 0.096,-0.95 -0.063,-0.319 -0.219,-0.612 -0.449,-0.842 -0.23,-0.23 -0.523,-0.386 -0.842,-0.449 -0.319,-0.063 -0.65,-0.03 -0.95,0.096 -0.3,0.125 -0.556,0.337 -0.736,0.608 -0.179,0.271 -0.274,0.59 -0.272,0.915 0.003,0.431 0.175,0.844 0.48,1.15 0.306,0.305 0.719,0.477 1.15,0.48 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3422"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "m 271.56862,889.1762 -1.7,-97 v -0.25 l -0.9,-25.51 23.39,0.25 -2.37,26.07 -6.65,96.13",
    fill: "#fc9d9d",
    id: "path3424"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m 321.17762,576.1762 c 0.027,0.249 0.004,0.5 -0.07,0.74 -0.069,0.241 -0.192,0.463 -0.36,0.65 -0.16,0.191 -0.357,0.347 -0.58,0.46 -0.225,0.111 -0.469,0.179 -0.719,0.2 v 0.11 l -0.5,2.46 -0.091,0.45 c 0,0.18 -0.08,0.35 -0.13,0.51 -1.31,5 -3.339,7.65 -7.839,7.65 h -2.261 l 0.23,3.26 c 0.11,1.5 5.5,1.47 7,1.85 l 2.18,3 -18.279,9.26 -22,-9.86 8.95,-2.72 c 3.44,-1.24 5.059,-3.82 6.3,-6 l 1.239,-3.66 -3.57,-24.87 8.76,-3.56 h 14.61 l 4.101,9.56 0.87,7.35 c 0.068,0.325 0.204,0.631 0.399,0.9 0.191,0.272 0.44,0.498 0.731,0.66 0.307,0.138 0.57,0.36 0.76,0.64 0.175,0.289 0.269,0.621 0.269,0.96 z",
    fill: "#fc9d9d",
    id: "path3426"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "m 308.24362,562.4062 c -1,-10.57 -8.15,-13.51 -16.12,-10.46 -7.97,3.05 -11.7,17.31 -8.23,27.37 3.47,10.06 14.1,12.16 19.46,8.85 4.61,-2.9 5.92,-15.18 4.89,-25.76 z",
    fill: "#231f20",
    id: "path3428"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "m 388.57062,617.9062 3,1.84 c 0.06,0.036 0.111,0.084 0.151,0.141 0.041,0.057 0.069,0.122 0.084,0.19 0.015,0.068 0.016,0.138 0.003,0.207 -0.013,0.068 -0.039,0.133 -0.078,0.192 -0.75,1.14 -2.64,4.31 -2.64,7.46 0.052,2.215 0.45,4.408 1.18,6.5 0.117,0.325 0.111,0.682 -0.018,1.003 -0.129,0.321 -0.372,0.583 -0.682,0.737 v 0 c -0.185,0.097 -0.39,0.151 -0.599,0.159 -0.209,0.007 -0.417,-0.032 -0.609,-0.116 -0.192,-0.083 -0.362,-0.209 -0.499,-0.367 -0.137,-0.158 -0.237,-0.345 -0.293,-0.546 -1.327,-4.639 -0.972,-9.597 1,-14 0.173,-0.387 0.241,-0.813 0.197,-1.234 -0.043,-0.421 -0.198,-0.824 -0.447,-1.166 l -0.3,-0.43 c -0.038,-0.051 -0.064,-0.11 -0.074,-0.173 -0.011,-0.063 -0.006,-0.127 0.014,-0.187 0.019,-0.06 0.052,-0.115 0.095,-0.16 0.044,-0.045 0.098,-0.08 0.157,-0.1 0.06,-0.02 0.123,-0.027 0.185,-0.018 0.062,0.009 0.122,0.032 0.173,0.068 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3430"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m 394.94762,615.6762 c 0.084,-0.224 0.128,-0.461 0.13,-0.7 -0.002,-0.284 -0.067,-0.564 -0.19,-0.82 l 0.62,-2.14 c 0.247,-0.858 0.194,-1.776 -0.15,-2.6 l -1.36,-3.24 h -0.55 c 0,0 0,1.16 0,2.81 0.243,0.058 0.459,0.196 0.614,0.392 0.155,0.196 0.239,0.438 0.239,0.688 0,0.25 -0.084,0.492 -0.239,0.688 -0.155,0.196 -0.371,0.334 -0.614,0.392 v 2 h -0.29 -0.29 c 0,-0.66 0,-1.32 0,-2 -0.243,-0.058 -0.46,-0.196 -0.615,-0.392 -0.155,-0.196 -0.239,-0.438 -0.239,-0.688 0,-0.25 0.084,-0.492 0.239,-0.688 0.155,-0.196 0.372,-0.334 0.615,-0.392 0,-1.65 0,-2.81 0,-2.81 h -0.54 l -1.36,3.24 c -0.349,0.823 -0.402,1.742 -0.15,2.6 l 0.62,2.14 c -0.124,0.256 -0.189,0.536 -0.19,0.82 0.001,0.239 0.045,0.476 0.13,0.7 l -1.58,3 1.73,1 1.32,-2.8 v -0.08 c 0.096,0.01 0.193,0.01 0.29,0 0.096,0.01 0.193,0.01 0.29,0 v 0.08 l 1.33,2.8 1.72,-1 z",
    fill: "#868a91",
    id: "path3432"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "m 397.76262,617.9052 -3,1.84 c -0.059,0.037 -0.111,0.085 -0.151,0.142 -0.04,0.057 -0.069,0.121 -0.084,0.189 -0.015,0.068 -0.016,0.139 -0.003,0.207 0.013,0.069 0.04,0.134 0.078,0.192 0.75,1.14 2.64,4.31 2.64,7.46 -0.054,2.216 -0.456,4.409 -1.19,6.5 -0.112,0.328 -0.099,0.685 0.035,1.004 0.135,0.319 0.382,0.578 0.695,0.726 0.183,0.088 0.383,0.135 0.586,0.138 0.204,0.003 0.405,-0.039 0.59,-0.121 0.186,-0.083 0.351,-0.205 0.485,-0.358 0.133,-0.154 0.232,-0.334 0.289,-0.529 1.333,-4.638 0.979,-9.598 -1,-14 -0.168,-0.388 -0.233,-0.812 -0.189,-1.233 0.043,-0.42 0.195,-0.822 0.439,-1.167 l 0.31,-0.43 c 0.032,-0.055 0.048,-0.117 0.048,-0.18 0,-0.063 -0.016,-0.125 -0.048,-0.18 v 0 c -0.022,-0.048 -0.052,-0.091 -0.091,-0.127 -0.038,-0.036 -0.083,-0.064 -0.132,-0.083 -0.05,-0.018 -0.102,-0.027 -0.155,-0.025 -0.052,0.001 -0.104,0.013 -0.152,0.035 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3434"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "m 393.18362,615.9972 c 0.602,0 1.09,-0.488 1.09,-1.09 0,-0.602 -0.488,-1.09 -1.09,-1.09 -0.602,0 -1.09,0.488 -1.09,1.09 0,0.602 0.488,1.09 1.09,1.09 z",
    fill: "#404041",
    id: "path3436"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "m 387.38262,628.4772 -4,9.08 c 0,0 8.001,-0.85 10.771,-2.82 2.77,-1.97 1.599,-3.38 1.599,-3.38 z",
    fill: "#fc9d9d",
    id: "path3438"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "m 395.12062,624.2662 c -0.112,-0.229 -0.309,-0.407 -0.549,-0.497 -0.24,-0.089 -0.505,-0.083 -0.741,0.017 l -6.18,2.81 c -0.065,0.034 -0.14,0.043 -0.211,0.027 -0.072,-0.017 -0.135,-0.058 -0.179,-0.117 -0.056,-0.059 -0.087,-0.138 -0.087,-0.22 0,-0.081 0.031,-0.16 0.087,-0.22 l 1.14,-1 c 0.809,-0.687 1.345,-1.641 1.51,-2.69 0.042,-0.181 0.043,-0.369 0.003,-0.55 -0.04,-0.182 -0.119,-0.352 -0.233,-0.5 v 0 c -0.111,-0.125 -0.267,-0.203 -0.434,-0.218 -0.167,-0.015 -0.334,0.035 -0.466,0.138 l -3.65,2.24 c -1.248,0.765 -2.346,1.751 -3.24,2.91 l -2,2.64 -9,8.11 3.77,6.69 8.72,-6.3 c 0,0 8.54,-3.24 11.28,-5.21 2.74,-1.97 1.27,-4 1.27,-4 1.51,-2.19 -0.78,-2.67 -0.78,-2.67 0.36,-0.16 -0.03,-1.39 -0.03,-1.39 z",
    fill: "#fc9d9d",
    id: "path3440"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    id: "g3444",
    transform: "translate(-224.42938,-142.8238)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 616.622,773.25 3.86,-1.85 c 0.029,-0.011 0.055,-0.029 0.077,-0.052 0.021,-0.022 0.038,-0.049 0.048,-0.078 0.01,-0.029 0.014,-0.06 0.012,-0.091 -0.003,-0.031 -0.012,-0.061 -0.027,-0.089 -0.013,-0.027 -0.032,-0.051 -0.055,-0.07 -0.024,-0.02 -0.05,-0.035 -0.079,-0.044 -0.029,-0.009 -0.059,-0.013 -0.089,-0.01 -0.03,0.002 -0.06,0.01 -0.087,0.024 l -3.86,1.85 c -0.027,0.014 -0.051,0.033 -0.07,0.056 -0.02,0.023 -0.035,0.05 -0.044,0.079 -0.009,0.028 -0.013,0.059 -0.01,0.089 0.002,0.03 0.01,0.059 0.024,0.086 0.015,0.029 0.034,0.054 0.058,0.074 0.024,0.021 0.052,0.037 0.082,0.046 0.054,0.013 0.111,0.006 0.16,-0.02 z",
    fill: "#000000",
    id: "path3442"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    id: "g3448",
    transform: "translate(-224.42938,-142.8238)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 616.4,776.189 3.86,-1.85 c 0.026,-0.012 0.05,-0.03 0.07,-0.052 0.019,-0.023 0.034,-0.048 0.043,-0.076 0.01,-0.028 0.013,-0.058 0.011,-0.087 -0.002,-0.03 -0.011,-0.058 -0.024,-0.085 -0.011,-0.028 -0.027,-0.054 -0.049,-0.075 -0.021,-0.022 -0.047,-0.038 -0.076,-0.049 -0.028,-0.01 -0.059,-0.014 -0.089,-0.012 -0.03,0.002 -0.06,0.011 -0.086,0.026 l -3.86,1.85 c -0.029,0.012 -0.055,0.03 -0.076,0.052 -0.022,0.023 -0.038,0.049 -0.049,0.079 -0.01,0.029 -0.014,0.06 -0.012,0.091 0.003,0.031 0.012,0.061 0.027,0.088 0.014,0.029 0.034,0.054 0.058,0.074 0.024,0.021 0.052,0.037 0.082,0.046 0.057,0.014 0.117,0.007 0.17,-0.02 z",
    fill: "#000000",
    id: "path3446"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    id: "g3452",
    transform: "translate(-224.42938,-142.8238)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 615.923,770.64 3.86,-1.85 c 0.056,-0.026 0.099,-0.074 0.119,-0.132 0.021,-0.058 0.018,-0.122 -0.009,-0.178 -0.027,-0.055 -0.074,-0.098 -0.132,-0.119 -0.058,-0.021 -0.122,-0.017 -0.178,0.009 l -3.86,1.86 c -0.029,0.011 -0.054,0.027 -0.076,0.049 -0.021,0.021 -0.038,0.047 -0.048,0.076 -0.011,0.028 -0.015,0.059 -0.012,0.089 0.002,0.03 0.011,0.06 0.026,0.086 0.028,0.06 0.078,0.107 0.14,0.13 0.057,0.014 0.117,0.007 0.17,-0.02 z",
    fill: "#000000",
    id: "path3450"
  }))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 395.79362,632.9962 c -2.37,1.77 -5.9,2.4 -8.86,2.49 l -3.27,0.15 c -0.367,0.02 -0.717,0.156 -1,0.39 l -3.21,2.62 0.94,1.37 3,-2.47 c 0,0 8,-0.84 10.76,-2.81 1.52,-1.19 1.65,-1.74 1.64,-1.74 z",
    fill: "#000000",
    id: "path3454"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m 389.77062,624.3752 c 0.504,-1.409 1.175,-2.751 2,-4 0.039,-0.058 0.065,-0.123 0.078,-0.192 0.013,-0.068 0.012,-0.139 -0.003,-0.207 -0.015,-0.068 -0.044,-0.132 -0.084,-0.189 -0.04,-0.057 -0.092,-0.105 -0.151,-0.142 l -3,-1.84 c -0.052,-0.032 -0.11,-0.051 -0.17,-0.057 -0.061,-0.006 -0.122,0.002 -0.179,0.024 -0.056,0.021 -0.108,0.055 -0.149,0.099 -0.042,0.043 -0.074,0.096 -0.092,0.154 -0.02,0.06 -0.025,0.125 -0.015,0.188 0.011,0.062 0.036,0.122 0.075,0.172 l 0.3,0.43 c 0.249,0.343 0.403,0.745 0.447,1.167 0.044,0.421 -0.024,0.846 -0.197,1.233 -0.646,1.611 -1.167,3.269 -1.56,4.96 h 0.5 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3456"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    id: "g3460",
    transform: "translate(-224.42938,-142.8238)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m 541.703,723.061 c -0.026,-0.038 -0.06,-0.069 -0.1,-0.09 -0.103,-0.068 -0.228,-0.093 -0.35,-0.07 -0.065,0.008 -0.126,0.032 -0.18,0.07 -0.05,0.033 -0.091,0.077 -0.12,0.13 -0.035,0.046 -0.06,0.1 -0.074,0.156 -0.013,0.057 -0.016,0.116 -0.006,0.174 0.014,0.116 0.071,0.223 0.16,0.3 0.288,0.277 0.628,0.495 1,0.64 0.362,0.146 0.75,0.221 1.14,0.22 v 0 c 0.05,-0.16 0.09,-0.33 0.13,-0.51 l 0.09,-0.45 c -0.3,0.032 -0.604,-0.002 -0.89,-0.1 -0.291,-0.092 -0.555,-0.253 -0.77,-0.47 z",
    fill: "#000000",
    id: "path3458"
  }))), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m 318.86762,576.7062 c -1.3,0 -2,-2.44 -2,-4.76 0,-2.32 0.7,-4.77 2,-4.77 1.3,0 2,2.44 2,4.77 0,2.33 -0.73,4.76 -2,4.76 z m 0,-9 c -0.59,0 -1.4,1.62 -1.4,4.24 0,2.62 0.81,4.24 1.4,4.24 0.59,0 1.4,-1.62 1.4,-4.24 0,-2.62 -0.85,-4.2 -1.4,-4.2 z",
    fill: "#21252b",
    id: "path3462"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "m 337.95462,890.0562 -20.57,-92.39 0.78,-4.66 -7,-26.58 24.87,0.71 4,25.22 9.91,98.13 z",
    fill: "#fc9d9d",
    id: "path3464"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "m 337.34362,887.3262 h 12.27 l 0.96,4.85 12.72,9.61 -23.72,0.39 z",
    fill: "#21252b",
    id: "path3466"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "m 377.79162,629.4272 -20.39,11.27 -24.12,-38.77 c -2.77,-2.799 -6.252,-4.787 -10.07,-5.75 l -7.4,-1.66 c -8.85,4.09 -23.38,3.36 -27.68,-0.78 l -8.06,1.52 c -0.26,0 -0.51,0.09 -0.77,0.14 l -9.12,1.7 c -1.938,0.373 -3.761,1.196 -5.324,2.401 -1.563,1.205 -2.822,2.759 -3.676,4.539 -0.461,0.952 -0.797,1.961 -1,3 l -9.53,46.38 c -0.436,2.118 -0.148,4.322 0.819,6.257 0.967,1.935 2.555,3.489 4.511,4.413 1.293,0.616 2.708,0.934 4.14,0.93 h 13.52 l 1.26,18.16 h 52.94 l -0.15,-41.89 c -0.008,-0.222 0.029,-0.444 0.11,-0.65 0.083,-0.206 0.205,-0.392 0.36,-0.55 l 1.6,-1.74 c 1.441,-1.475 2.504,-3.276 3.1,-5.25 0.311,-1.09 0.469,-2.217 0.47,-3.35 0,-1.3 -0.58,1.65 -0.76,0.37 l 17.92,28 c 1.264,0.973 2.815,1.5 4.41,1.5 1.595,0 3.146,-0.527 4.41,-1.5 l 24.87,-19.94 z m -109.68,22.58 3.38,-17.44 1.23,17.52 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3468"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 377.79162,629.4272 -20.39,11.27 -24.12,-38.77 c -2.77,-2.799 -6.252,-4.787 -10.07,-5.75 l -7.4,-1.66 c -8.85,4.09 -23.38,3.36 -27.68,-0.78 l -8.06,1.52 c -0.26,0 -0.51,0.09 -0.77,0.14 l -9.12,1.7 c -1.938,0.373 -3.761,1.196 -5.324,2.401 -1.563,1.205 -2.822,2.759 -3.676,4.539 -0.461,0.952 -0.797,1.961 -1,3 l -9.53,46.38 c -0.436,2.118 -0.148,4.322 0.819,6.257 0.967,1.935 2.555,3.489 4.511,4.413 1.293,0.616 2.708,0.934 4.14,0.93 h 13.52 l 1.26,18.16 h 52.94 l -0.15,-41.89 c -0.008,-0.222 0.029,-0.444 0.11,-0.65 0.083,-0.206 0.205,-0.392 0.36,-0.55 l 1.6,-1.74 c 1.441,-1.475 2.504,-3.276 3.1,-5.25 0.311,-1.09 0.469,-2.217 0.47,-3.35 0,-1.3 -0.58,1.65 -0.76,0.37 l 17.92,28 c 1.264,0.973 2.815,1.5 4.41,1.5 1.595,0 3.146,-0.527 4.41,-1.5 l 24.87,-19.94 z m -109.68,22.58 3.38,-17.44 1.23,17.52 z",
    fill: "#000000",
    id: "path3470"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m 272.72162,652.0572 -4.61,-0.07 3.38,-17.42 -0.08,0.05 c -0.566,0.341 -1.053,0.797 -1.43,1.34 -0.382,0.539 -0.648,1.152 -0.78,1.8 l -3.19,15.47 c -0.015,0.082 -0.015,0.167 0,0.25 0.016,0.082 0.054,0.158 0.11,0.22 0.051,0.063 0.116,0.114 0.19,0.15 0.078,0.036 0.164,0.054 0.25,0.05 h 6.28 z",
    fill: "#000000",
    id: "path3472"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m 272.67062,632.0762 -1.17,2.46 3.4,48.64 h 3.67 l -4.8,-50.91 c -0.013,-0.126 -0.067,-0.244 -0.154,-0.336 -0.086,-0.092 -0.2,-0.154 -0.324,-0.175 -0.125,-0.022 -0.253,-0.002 -0.365,0.056 -0.112,0.058 -0.203,0.151 -0.257,0.265 z",
    fill: "#000000",
    id: "path3474"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "m 327.83862,681.8772 -0.15,-40.53 c -0.008,-0.222 0.029,-0.443 0.11,-0.65 0.083,-0.205 0.205,-0.392 0.36,-0.55 l 1.6,-1.74 c 1.441,-1.475 2.504,-3.276 3.1,-5.25 0.31,-1.09 0.469,-2.217 0.47,-3.35 0,-0.66 0,-1.31 -0.1,-2 l -0.66,-1.63 c -3.36,8.2 -7.08,18.17 -9,22 l -0.06,0.12 c -0.339,0.614 -0.873,1.096 -1.519,1.37 -0.645,0.274 -1.364,0.323 -2.041,0.14 -0.676,-0.184 -1.272,-0.589 -1.691,-1.151 -0.419,-0.562 -0.637,-1.248 -0.619,-1.949 l 1,-51.51 -4,-0.14 -5.07,43.12 h -24 l -4.24,-43.12 -1.26,0.24 c -0.26,0 -0.51,0.09 -0.77,0.14 l -2.56,0.48 0.64,48.65 c 0.169,2.185 -0.174,4.38 -1,6.41 -0.71,1.54 -2.89,4.63 -3.82,3.2 l 1.06,10.84 1.18,16.86 c 0,0 -6.7,23 -7.47,45.14 l 3.24,155.159 h 13.72 l 14.11,-153.419 c 0.042,-0.417 0.231,-0.804 0.534,-1.094 0.302,-0.289 0.698,-0.461 1.116,-0.486 0.417,-0.024 0.83,0.102 1.164,0.355 0.333,0.253 0.566,0.616 0.656,1.025 l 33.7,153.619 h 14.36 z",
    fill: "#3f4249",
    id: "path3476"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 336.53162,883.6862 8.04,1.49 2,8 14.85,7.3 -10.85,-8.3 -1.48,-10 h -12.56 z",
    fill: "#000000",
    id: "path3478"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "m 293.73862,602.7662 c 0.74,4 -1.24,8.06 -2.81,11.2 -1.23,2.47 -0.6,7.69 2.42,11.37 1.11,-0.413 2.108,-1.08 2.914,-1.949 0.806,-0.868 1.397,-1.913 1.726,-3.051 1.34,-4.07 -0.15,-9.17 -0.59,-12.3 -0.307,-1.634 -0.197,-3.32 0.32,-4.9 z",
    fill: "#21252b",
    id: "path3480"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "m 301.40762,552.4452 c -3.72,-2.78 -5.17,-3.2 -9.54,0.77 -4.37,3.97 -3.65,7.39 -5.11,13.17 -1.46,5.78 -2.08,12.79 1.1,19.33 0,0 -0.22,5.16 3.27,8.46 0,0 -0.8,6.22 3.47,9.45 0.372,0.319 0.845,0.494 1.335,0.494 0.49,0 0.963,-0.175 1.335,-0.494 1.37,-1.14 2.89,-5.22 2.78,-8.73 1.779,-1.428 2.962,-3.467 3.32,-5.72 0,0 2.93,-1.91 4.21,-10 1.8,-11.44 1.87,-26.22 -6.17,-26.73 z",
    fill: "#21252b",
    id: "path3482"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m 295.35962,604.0252 c 0.329,0.098 0.677,0.11 1.011,0.035 0.335,-0.075 0.644,-0.235 0.899,-0.465 1.37,-1.14 2.89,-5.22 2.78,-8.73 -1.38,1.06 -2.659,2.245 -3.82,3.54 -0.636,1.804 -0.931,3.709 -0.87,5.62 z",
    fill: "#21252b",
    id: "path3484"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "m 297.17262,591.8862 c -1.022,1.072 -1.694,2.429 -1.93,3.89 l 0.61,1.25 3.17,-2.2 0.09,-3 z",
    fill: "#21252b",
    id: "path3486"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m 302.78062,568.6762 -6.11,14.14 c -0.919,2.921 -0.719,6.078 0.56,8.86",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    id: "path3488"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m 290.46162,573.8072 c 0,0 6.52,3.92 7.19,6.76",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    id: "path3490"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m 288.03962,585.4962 c 0,0 1.47,2.63 8,0.58",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    id: "path3492"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m 291.10962,594.3852 c 0,0 3.38,-0.1 4.12,1.21 0,0 -0.5,-4.29 8.11,-6.63",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    id: "path3494"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m 295.45462,603.4362 c 0,0 -1.3,-5 4.45,-8.35",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    id: "path3496"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m 295.22662,595.5962 c 0,0 0.22,2.44 1.05,2.57",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    id: "path3498"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "m 297.55062,605.8872 -4.16,-0.62 0.19,-2.38 4.16,0.62 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3500"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "m 271.34362,887.3262 h 12.27 l -0.04,4.85 13.72,9.61 -25.72,0.39 z",
    fill: "#21252b",
    id: "path3502"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "m 312.57062,565.1762 c -1.16,3.28 -2.83,26.5 -2.83,26.5 -0.668,-0.644 -1.192,-1.423 -1.537,-2.285 -0.344,-0.862 -0.502,-1.787 -0.463,-2.715 l 0.83,-21.5 c 0,0 4.27,-0.77 4,0 z",
    fill: "#21252b",
    id: "path3504"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 271.57062,883.6862 7.04,1.49 2,8 14.85,7.3 -11.85,-8.3 0.52,-10 h -12.56 z",
    fill: "#000000",
    id: "path3506"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "m 272.06162,896.6362 5.44,1.76 c 0.39,0.13 0.806,0.15 1.207,0.07 0.401,-0.09 0.771,-0.28 1.073,-0.56 l 4.29,-3.82 c 0.46,-0.42 1.056,-0.66 1.679,-0.68 0.622,-0.01 1.23,0.2 1.711,0.59 l 9.69,7.85 7.64,2.63 c 1.115,0.41 2.076,1.16 2.753,2.13 0.676,0.98 1.035,2.14 1.027,3.33 0.006,0.33 -0.119,0.65 -0.347,0.89 -0.229,0.24 -0.542,0.38 -0.873,0.39 h -33.87 c -0.78,-0.02 -1.52,-0.35 -2.063,-0.91 -0.543,-0.56 -0.847,-1.31 -0.847,-2.09 v -10.4 c -0.008,-0.19 0.027,-0.37 0.104,-0.54 0.077,-0.17 0.193,-0.32 0.339,-0.43 0.145,-0.12 0.316,-0.2 0.498,-0.23 0.183,-0.04 0.371,-0.03 0.549,0.02 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3508"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "m 270.57062,908.6662 h 37.8 c 0.115,0.41 0.169,0.84 0.16,1.27 0.005,0.33 -0.119,0.65 -0.348,0.89 -0.228,0.24 -0.541,0.38 -0.872,0.39 h -33.83 c -0.708,-0.01 -1.388,-0.28 -1.921,-0.74 -0.533,-0.47 -0.883,-1.11 -0.989,-1.81 z",
    fill: "#21252b",
    id: "path3510"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "m 287.50262,898.0662 2.05,-2.3 c 0.053,-0.06 0.082,-0.14 0.082,-0.23 0,-0.08 -0.029,-0.16 -0.082,-0.22 -0.028,-0.03 -0.062,-0.06 -0.1,-0.07 -0.038,-0.02 -0.079,-0.03 -0.12,-0.03 -0.042,0 -0.082,0.01 -0.12,0.03 -0.038,0.01 -0.072,0.04 -0.1,0.07 l -2,2.3 c -0.057,0.06 -0.089,0.14 -0.089,0.22 0,0.09 0.032,0.17 0.089,0.23 0.052,0.05 0.124,0.09 0.2,0.09 0.069,-0.02 0.134,-0.05 0.19,-0.09 z",
    fill: "#ffffff",
    id: "path3512"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m 289.10962,899.3862 2.05,-2.3 c 0.057,-0.06 0.088,-0.14 0.088,-0.22 0,-0.09 -0.031,-0.17 -0.088,-0.23 -0.027,-0.03 -0.06,-0.05 -0.097,-0.07 -0.038,-0.02 -0.078,-0.02 -0.118,-0.02 -0.041,0 -0.081,0 -0.118,0.02 -0.037,0.02 -0.07,0.04 -0.097,0.07 l -2,2.3 c -0.057,0.06 -0.089,0.14 -0.089,0.23 0,0.08 0.032,0.16 0.089,0.22 0.025,0.03 0.056,0.05 0.09,0.07 0.035,0.01 0.072,0.02 0.11,0.02 0.065,-0.02 0.127,-0.05 0.18,-0.09 z",
    fill: "#ffffff",
    id: "path3514"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m 290.72862,900.6962 2.05,-2.3 c 0.057,-0.06 0.089,-0.14 0.089,-0.23 0,-0.08 -0.032,-0.16 -0.089,-0.22 -0.028,-0.03 -0.062,-0.05 -0.1,-0.07 -0.038,-0.02 -0.078,-0.03 -0.12,-0.03 -0.041,0 -0.082,0.01 -0.12,0.03 -0.038,0.02 -0.072,0.04 -0.1,0.07 l -2,2.3 c -0.057,0.06 -0.088,0.14 -0.088,0.22 0,0.09 0.031,0.17 0.088,0.23 0.024,0.03 0.053,0.05 0.085,0.07 0.033,0.01 0.069,0.02 0.105,0.02 0.076,0 0.147,-0.04 0.2,-0.09 z",
    fill: "#ffffff",
    id: "path3516"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m 339.06162,896.6362 5.44,1.76 c 0.39,0.13 0.806,0.15 1.207,0.07 0.401,-0.09 0.771,-0.28 1.073,-0.56 l 4.29,-3.82 c 0.46,-0.42 1.056,-0.66 1.679,-0.68 0.622,-0.01 1.23,0.2 1.711,0.59 l 9.69,7.85 7.64,2.63 c 1.115,0.41 2.076,1.16 2.753,2.13 0.676,0.98 1.035,2.14 1.027,3.33 0.006,0.33 -0.119,0.65 -0.347,0.89 -0.229,0.24 -0.542,0.38 -0.873,0.39 h -33.87 c -0.78,-0.02 -1.52,-0.35 -2.063,-0.91 -0.543,-0.56 -0.847,-1.31 -0.847,-2.09 v -10.4 c -0.008,-0.19 0.027,-0.37 0.104,-0.54 0.077,-0.17 0.193,-0.32 0.339,-0.43 0.145,-0.12 0.316,-0.2 0.498,-0.23 0.183,-0.04 0.371,-0.03 0.549,0.02 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3518"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m 337.57062,908.6662 h 37.8 c 0.115,0.41 0.169,0.84 0.16,1.27 0.005,0.33 -0.119,0.65 -0.348,0.89 -0.228,0.24 -0.541,0.38 -0.872,0.39 h -33.83 c -0.708,-0.01 -1.388,-0.28 -1.921,-0.74 -0.533,-0.47 -0.883,-1.11 -0.989,-1.81 z",
    fill: "#21252b",
    id: "path3520"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m 354.50262,898.0662 2.05,-2.3 c 0.053,-0.06 0.082,-0.14 0.082,-0.23 0,-0.08 -0.029,-0.16 -0.082,-0.22 -0.028,-0.03 -0.062,-0.06 -0.1,-0.07 -0.038,-0.02 -0.079,-0.03 -0.12,-0.03 -0.042,0 -0.082,0.01 -0.12,0.03 -0.038,0.01 -0.072,0.04 -0.1,0.07 l -2,2.3 c -0.057,0.06 -0.089,0.14 -0.089,0.22 0,0.09 0.032,0.17 0.089,0.23 0.052,0.05 0.124,0.09 0.2,0.09 0.069,-0.02 0.134,-0.05 0.19,-0.09 z",
    fill: "#ffffff",
    id: "path3522"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m 356.10962,899.3862 2.05,-2.3 c 0.057,-0.06 0.088,-0.14 0.088,-0.22 0,-0.09 -0.031,-0.17 -0.088,-0.23 -0.027,-0.03 -0.06,-0.05 -0.097,-0.07 -0.038,-0.02 -0.078,-0.02 -0.118,-0.02 -0.041,0 -0.081,0 -0.118,0.02 -0.037,0.02 -0.07,0.04 -0.097,0.07 l -2,2.3 c -0.057,0.06 -0.089,0.14 -0.089,0.23 0,0.08 0.032,0.16 0.089,0.22 0.025,0.03 0.056,0.05 0.09,0.07 0.035,0.01 0.072,0.02 0.11,0.02 0.065,-0.02 0.127,-0.05 0.18,-0.09 z",
    fill: "#ffffff",
    id: "path3524"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m 357.72862,900.6962 2.05,-2.3 c 0.057,-0.06 0.089,-0.14 0.089,-0.23 0,-0.08 -0.032,-0.16 -0.089,-0.22 -0.028,-0.03 -0.062,-0.05 -0.1,-0.07 -0.038,-0.02 -0.078,-0.03 -0.12,-0.03 -0.041,0 -0.082,0.01 -0.12,0.03 -0.038,0.02 -0.072,0.04 -0.1,0.07 l -2,2.3 c -0.057,0.06 -0.088,0.14 -0.088,0.22 0,0.09 0.031,0.17 0.088,0.23 0.024,0.03 0.053,0.05 0.085,0.07 0.033,0.01 0.069,0.02 0.105,0.02 0.076,0 0.147,-0.04 0.2,-0.09 z",
    fill: "#ffffff",
    id: "path3526"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m 354.90062,659.7162 c 1.595,0 3.146,-0.527 4.41,-1.5 l 24.87,-20.04 -1.54,-2.1 -24.8,18.67 c -0.421,0.319 -0.903,0.549 -1.416,0.676 -0.512,0.126 -1.046,0.147 -1.567,0.061 -0.521,-0.086 -1.019,-0.277 -1.464,-0.562 -0.445,-0.285 -0.827,-0.658 -1.123,-1.095 l -18.7,-27.65 v 5.56 l 16.92,26.44 c 1.259,0.987 2.81,1.529 4.41,1.54 z",
    fill: "#000000",
    id: "path3528"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 273.57362,731.1762 c -1,-24 7.09,-48 7.09,-48 l -3.09,-37 -0.21,-0.23 v 1.62 c 0.08,2.28 -0.11,1.509 -1,3.409 -0.71,1.54 -2.89,4.631 -3.82,3.201 l 1.06,13.84 0.97,14.16 c 0,0 -6.46,25.68 -7.23,47.84 l 3.23,152.16 h 5.15 z",
    fill: "#000000",
    id: "path3530"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 300.57062,727.1772 v 0.07 c 0.316,0.076 0.604,0.239 0.832,0.47 0.228,0.232 0.387,0.523 0.458,0.84 l 33.71,153.619 h 5.29 l -32.89,-151.149 c -0.158,-0.745 -0.471,-1.448 -0.92,-2.063 -0.449,-0.615 -1.022,-1.128 -1.683,-1.506 -0.662,-0.378 -1.395,-0.612 -2.153,-0.686 -0.757,-0.074 -1.522,0.013 -2.244,0.255 -0.136,0.043 -0.269,0.093 -0.4,0.15 z",
    fill: "#000000",
    id: "path3532"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 292.57062,677.1762 h -2 v 9 h 2 z",
    fill: "#000000",
    id: "path3534"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 311.57062,677.1762 h -2 v 9 h 2 z",
    fill: "#000000",
    id: "path3536"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m 319.57062,566.1762 c 0,0 -5.35,2.75 -6.67,5.88 l -1.33,-5.88 8,-3 z",
    fill: "#21252b",
    id: "path3538"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 286.76262,583.8562 c -3.79,-5.61 -4.4,-7.66 -5.34,-13.6 l 16.84,-9.59 7.95,5.13 c -1.78,3.53 -2.63,4.2 -6.54,5 -2.63,0.56 -3.93,0 -5.32,0.87",
    fill: "#b2b6bb",
    id: "path3540"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 278.47762,576.0452 -1.23,-3.78 c -0.67,-1.76 -0.14,-1.9 1.33,-2.62 -2.05,-14.72 5.29,-22.08 15.65,-23.64 11.17,-1.7 15.25,2.66 19.82,7.7 5.6,6.17 3.92,5.82 12.26,7.37 0.93,1.45 -3.25,2.76 -8.42,4.25 -4.09,1.17 -8.63,2.52 -11.06,2.51 -8.25,0 -15.21,0.61 -20.55,7.78 l -5.24,1.28 c -1.85,0.52 -2.18,0.35 -2.56,-0.85 z",
    className: "change-color-in-svg",
    fill: "#4d61fc",
    id: "path3542"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 278.47762,576.0462 -1.23,-3.78 c -0.67,-1.76 -0.14,-1.9 1.33,-2.62 -2.05,-14.72 5.29,-22.08 15.65,-23.64 0.39,-0.07 0.78,-0.12 1.16,-0.16 -8.17,4.26 -11.16,10.26 -8.85,20.3 10.44,-3.09 20.55,-6.07 31.27,-7.53 -8.9,2.41 -25,6.55 -28.9,9 -1.39,0.86 -0.68,1.81 -0.38,3.37 l 0.58,1.57 c -1.052,0.921 -2.001,1.954 -2.83,3.08 l -5.24,1.28 c -1.85,0.5 -2.18,0.33 -2.56,-0.87 z",
    fill: "#000000",
    id: "path3544"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanel);
export default __webpack_public_path__ + "static/media/solar-panel.abc3acafcf68668f93a8c76609454d72.svg";
export { ForwardRef as ReactComponent };